<template>
    <div>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Registro de información financiera</h4>
        </div>
        <form v-if="!form.er.locked" @submit.prevent="validateForm('formER')" data-vv-scope="formER">
            <card  id="toERElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Información adicional</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Endeudamiento *</label>
                        <vue-numeric  :disabled="agro" :max=999999999999999 tabindex="0" currency="$" autocomplete="off" name="endeudamiento" v-validate="modelValidations.indebtness" :error="getError('endeudamiento')" separator="." class="form-control" v-model="form.indebtness"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Tipo de cartera *</label>
                        <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="form.debt.cial" :checked="false">CIAL</p-checkbox>
                            <p-checkbox v-model="form.debt.mc" class="ml-2" :checked="false">MC</p-checkbox>
                        </div>
                    </div>
                    <h6 class="orange">Estado de resultados (Gastos operativos)</h6>
                    <div v-show="!agro" class="form-group">
                        <label>Número de empleados *</label>
                        <fg-input   type="number"
                                    tabindex="1"
                                    name="empleados"
                                    placeholder="empleados"
                                    autocomplete="off"
                                    v-validate="modelValidations.employees"
                                    data-vv-id = "formER.empleados"
                                    :error="getError('formER.empleados')"
                                    v-model="form.er.employees">
                        </fg-input>
                    </div>
                    <div v-show="!agro" class="form-group">
                        <label>Ingresos por ventas al contado *</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="2" currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.indebtness" data-vv-id = "formER.ingresos" :error="getError('formER.ingresos')" separator="." class="form-control" v-model="form.er.account_sales"></vue-numeric>
                    </div>
                    <div v-show="agro" class="form-group">
                        <label>Ingresos por ventas*</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="2" currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.indebtness" data-vv-id = "formER.ingresos" :error="getError('formER.ingresos')" separator="." class="form-control" v-model="form.er.account_sales"></vue-numeric>
                    </div>
                    <div  v-show="!agro" class="form-group">
                        <label>Recuperación de ventas a crédito *</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="3" currency="$" autocomplete="off" name="recuperación" v-validate="modelValidations.indebtness" data-vv-id = "formER.recuperación" :error="getError('formER.recuperación')" separator="." class="form-control" v-model="form.er.credit_sales"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Costo de ventas *</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="4" currency="$" autocomplete="off" name="costo" v-validate="modelValidations.indebtness" data-vv-id = "formER.costo" :error="getError('formER.costo')" separator="." class="form-control" v-model="form.er.sales_costs"></vue-numeric>
                    </div>
                    <div v-show="!agro" class="form-group">
                        <label>Utilidad bruta *</label>
                        <vue-numeric  :max=999999999999999 disabled currency="$" autocomplete="off" name="utilidad" v-validate="modelValidations.indebtness" data-vv-id = "formER.utilidad" :error="getError('formER.utilidad')" separator="." class="form-control" v-model="gross_profit_computed"></vue-numeric>
                    </div>
                    <div v-show="agro" class="form-group">
                        <label>Utilidad operativa *</label>
                        <vue-numeric  :max=999999999999999 disabled currency="$" autocomplete="off" name="utilidad" v-validate="modelValidations.indebtness" data-vv-id = "formER.utilidad" :error="getError('formER.utilidad')" separator="." class="form-control" v-model="gross_profit_computed"></vue-numeric>
                    </div>
                    <hr>
                    <div class="form-group">
                        <h6 class="white">GASTOS OPERATIVOS</h6>
                        <div class="form-group">
                            <label>Salarios</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.salaries.locked" tabindex="5" currency="$" autocomplete="off" name="salarios" v-validate="modelValidations.sales" data-vv-id = "formER.salarios" :error="getError('formER.salarios')" separator="." class="form-control" v-model="form.er.operative_expenses.salaries.value"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Alquiler</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.rental.locked" tabindex="6" currency="$" autocomplete="off" name="alquiler" v-validate="modelValidations.sales" data-vv-id = "formER.alquiler" :error="getError('formER.alquiler')" separator="." class="form-control" v-model="form.er.operative_expenses.rental.value"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Servicios públicos</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.public_services.locked" tabindex="7" currency="$" autocomplete="off" name="servicios" v-validate="modelValidations.sales" data-vv-id = "formER.servicios" :error="getError('formER.servicios')" separator="." class="form-control" v-model="form.er.operative_expenses.public_services.value"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Impuestos</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.taxes.locked" tabindex="8" currency="$" autocomplete="off" name="impuestos" v-validate="modelValidations.sales" data-vv-id = "formER.impuestos" :error="getError('formER.impuestos')" separator="." class="form-control" v-model="form.er.operative_expenses.taxes.value"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Transporte</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.transport.locked" tabindex="9" currency="$" autocomplete="off" name="transporte" v-validate="modelValidations.sales" data-vv-id = "formER.transporte" :error="getError('formER.transporte')" separator="." class="form-control" v-model="form.er.operative_expenses.transport.value"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Gastos financieros</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.financial_expenses.locked" tabindex="10" currency="$" autocomplete="off" name="gastos" v-validate="modelValidations.sales" data-vv-id = "formER.gastos" :error="getError('formER.gastos')" separator="." class="form-control" v-model="form.er.operative_expenses.financial_expenses.value"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Otros gastos</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.others.locked" tabindex="11" currency="$" autocomplete="off" name="gastos" v-validate="modelValidations.sales" data-vv-id = "formER.otros" :error="getError('formER.otros')" separator="." class="form-control" v-model="form.er.operative_expenses.others.value"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Imprevistos</label>
                            <vue-numeric  :max=999999999999999 :disabled="form.er.operative_expenses.incidentals.locked" tabindex="12" currency="$" autocomplete="off" name="gastos" v-validate="modelValidations.sales" data-vv-id = "formER.imprevistos" :error="getError('formER.imprevistos')" separator="." class="form-control" v-model="form.er.operative_expenses.incidentals.value"></vue-numeric>
                        </div>
                        <div class="alert alert-warning mt-2">
                            <span>TOTAL GASTOS OPERATIVOS: {{setFormat(operative_expenses_computed)}}</span>
                        </div>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>UTILIDAD NETA: {{setFormat(net_profit_computed)}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button @click="validateForm('formER')" class="btn btn-warning">Siguiente</p-button>
                        <p-button @click="toBusinessReferences()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.if.locked" @submit.prevent="validateForm('formIF')" data-vv-scope="formIF">
            <card  id="toIFElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Ingresos familiares</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Ingresos del negocio</label>
                        <vue-numeric  :max=999999999999999 tabindex="13" currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.sales" data-vv-id = "formIF.ingresos" :error="getError('formIF.ingresos')" separator="." class="form-control" v-model="form.if.incomes.business_income"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Salario/Pensión titular</label>
                        <vue-numeric  :max=999999999999999 tabindex="14" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.titular_salary"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Salario/Pensión cónyuge</label>
                        <vue-numeric  :max=999999999999999 :disabled="!pyme" tabindex="15" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.spouse_salary"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otros ingresos netos</label>
                        <!-- <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(1)" tabindex="16" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="form.if.incomes.others"></vue-numeric> -->
                        <vue-numeric  :max=999999999999999 id="otherIncomes" v-on:focus="otherIncomesFocus()" tabindex="16" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="incomes_others_computed"></vue-numeric>
                    </div>
                    <el-table v-if="form.if.otherIncomes.length" :data="form.if.otherIncomes"  ref="incomesTable"  highlight-current-row @current-change="handleCurrentIncomesChange">
                        <el-table-column label="Tipo">
                            <template slot-scope="scope">
                                <span >{{ setIncomeType(scope.row.incomeType)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.incomeValue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <p-button v-if="currentIncomesRow"
                        @click="editIncomesMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar
                    </p-button>
                    <br>
                    <p-button v-if="currentIncomesRow"
                        @click="removeIncomesMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar
                    </p-button>
                    <div class="alert alert-warning mt-2">
                        <span>Total ingresos: {{setFormat(family_income_computed)}}</span>
                    </div>
                    <!--Egresos personales, solo pyme-->
                    <div v-show="pyme" class="pyme-data">
                        <h6 class="orange">Egresos personales</h6>
                        <el-table v-if="form.if.personalExpenses.length && pyme" :data="form.if.personalExpenses"  ref="personalExpensesTable"  highlight-current-row @current-change="handleCurrentPersonalExpensesChange">
                            <el-table-column label="Gasto" property="personalExpenseName"></el-table-column>
                            <el-table-column label="Valor">
                                <template slot-scope="scope">
                                    <span >{{ setFormat(scope.row.personalExpenseValue)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div>
                            <p-button 
                                @click="addPersonalExpenseMethod()"
                                type="default" 
                                >
                                <i class="mr-2 fa fa-plus"></i>Agregar gasto
                            </p-button>
                            <br>
                            <p-button v-if="currentPersonalExpenseRow"
                                @click="editPersonalExpenseMethod()"
                                type="default" 
                                >
                                <i class="mr-2 fa fa-pencil"></i>Editar gasto
                            </p-button>
                            <br>
                            <p-button v-if="currentPersonalExpenseRow"
                                @click="removePersonalExpenseMethod()"
                                type="default" 
                                >
                                <i class="mr-2 fa fa-minus"></i>Quitar gasto
                            </p-button>
                        </div>
                    </div>
                    <!--Finaliza egresos personales, solo pyme-->
                    <div v-show="!pyme" class="pyme-data">
                        <h6 class="orange">Egresos de la unidad familiar</h6>
                        <div class="form-group">
                            <label>Alquiler</label>
                            <vue-numeric  :max=999999999999999 tabindex="17" currency="$" autocomplete="off" name="alquiler" v-validate="modelValidations.sales" data-vv-id = "formIF.alquiler" :error="getError('formIF.alquiler')" separator="." class="form-control" v-model="form.if.expenses.rental"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Alimentación</label>
                            <vue-numeric  :max=999999999999999 tabindex="18" currency="$" autocomplete="off" v-validate="agro ?  modelValidations.salesTrue : modelValidations.sales" data-vv-id = "formIF.alimentación" data-vv-name = "formIF.alimentación" separator="." class="form-control" v-model="form.if.expenses.feeding"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Servicios públicos</label>
                            <vue-numeric  :max=999999999999999 tabindex="19" currency="$" autocomplete="off" name="servicios" v-validate="modelValidations.sales" data-vv-id = "formIF.servicios" :error="getError('formIF.servicios')" separator="." class="form-control" v-model="form.if.expenses.public_services"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Educación</label>
                            <vue-numeric  :max=999999999999999 tabindex="20" currency="$" autocomplete="off" name="educación" v-validate="modelValidations.sales" data-vv-id = "formIF.educación" :error="getError('formIF.educación')" separator="." class="form-control" v-model="form.if.expenses.education"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Salud</label>
                            <vue-numeric  :max=999999999999999 tabindex="21" currency="$" autocomplete="off" name="salud" v-validate="modelValidations.sales" data-vv-id = "formIF.salud" :error="getError('formIF.salud')" separator="." class="form-control" v-model="form.if.expenses.health"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Cuotas créditos recibidos por UF</label>
                            <vue-numeric  :max=999999999999999 tabindex="22" currency="$" autocomplete="off" name="cuotas" v-validate="modelValidations.sales" data-vv-id = "formIF.cuotas" :error="getError('formIF.cuotas')" separator="." class="form-control" v-model="form.if.expenses.credits"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Transporte</label>
                            <vue-numeric  :max=999999999999999 tabindex="23" currency="$" autocomplete="off" name="transporte" v-validate="modelValidations.sales" data-vv-id = "formIF.transporte" :error="getError('formIF.transporte')" separator="." class="form-control" v-model="form.if.expenses.transport"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Otros</label>
                            <vue-numeric  :max=999999999999999 tabindex="24" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="form.if.expenses.others"></vue-numeric>
                        </div>
                        <div v-if="!agro" class="form-group">
                            <label>Imprevistos * 10%</label>
                            <vue-numeric  :max=999999999999999 tabindex="25" currency="$" autocomplete="off" name="imprevistos" v-validate="modelValidations.sales" data-vv-id = "formIF.imprevistos" :error="getError('formIF.imprevistos')" separator="." class="form-control" v-model="family_expenses_incidentals_computed"></vue-numeric>
                        </div>
                        <div v-else class="form-group">
                            <label>Imprevistos * 20%</label>
                            <vue-numeric  :max=999999999999999 tabindex="25" currency="$" autocomplete="off" name="imprevistos" v-validate="modelValidations.sales" data-vv-id = "formIF.imprevistos" :error="getError('formIF.imprevistos')" separator="." class="form-control" v-model="family_expenses_incidentals_computed"></vue-numeric>
                        </div>
                        <div class="alert alert-warning mt-2">
                            <span>TOTAL EGRESOS UF: {{setFormat(family_expenses_computed)}}</span>
                        </div>
                        <div class="alert alert-success mt-2">
                            <span>EXCEDENTE: {{setFormat(family_surplus_computed)}}</span>
                        </div>
                    </div>
                </div>
                <!-- <div v-show="!pyme" class="pyme-data">
                    <div class="card-header">
                        <h6 class="card-title-orange">Egresos personales</h6>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label>Ingresos del negocio</label>
                            <vue-numeric  :max=999999999999999 tabindex="13" currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.sales" data-vv-id = "formIF.ingresos" :error="getError('formIF.ingresos')" separator="." class="form-control" v-model="form.if.incomes.business_income"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Salario/Pensión titular</label>
                            <vue-numeric  :max=999999999999999 tabindex="14" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.titular_salary"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Salario/Pensión cónyuge</label>
                            <vue-numeric  :max=999999999999999 disabled tabindex="15" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.spouse_salary"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Otros ingresos netos</label>
                            <vue-numeric  :max=999999999999999 id="otherIncomes" v-on:focus="otherIncomesFocus()" tabindex="16" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="incomes_others_computed"></vue-numeric>
                        </div>
                        <el-table v-if="form.if.otherIncomes.length" :data="form.if.otherIncomes"  ref="incomesTable"  highlight-current-row @current-change="handleCurrentIncomesChange">
                            <el-table-column label="Tipo">
                                <template slot-scope="scope">
                                    <span >{{ setIncomeType(scope.row.incomeType)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Valor">
                                <template slot-scope="scope">
                                    <span >{{ setFormat(scope.row.incomeValue)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <p-button v-if="currentIncomesRow"
                            @click="editIncomesMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar
                        </p-button>
                        <br>
                        <p-button v-if="currentIncomesRow"
                            @click="removeIncomesMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar
                        </p-button>
                        <div class="alert alert-warning mt-2">
                            <span>Total ingresos: {{setFormat(family_income_computed)}}</span>
                        </div>
                        <h6 class="orange">Egresos de la unidad familiar</h6>
                        <div class="form-group">
                            <label>Alquiler</label>
                            <vue-numeric  :max=999999999999999 tabindex="17" currency="$" autocomplete="off" name="alquiler" v-validate="modelValidations.sales" data-vv-id = "formIF.alquiler" :error="getError('formIF.alquiler')" separator="." class="form-control" v-model="form.if.expenses.rental"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Alimentación</label>
                            <vue-numeric  :max=999999999999999 tabindex="18" currency="$" autocomplete="off" name="alimentación" v-validate="modelValidations.sales" data-vv-id = "formIF.alimentación" :error="getError('formIF.alimentación')" separator="." class="form-control" v-model="form.if.expenses.feeding"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Servicios públicos</label>
                            <vue-numeric  :max=999999999999999 tabindex="19" currency="$" autocomplete="off" name="servicios" v-validate="modelValidations.sales" data-vv-id = "formIF.servicios" :error="getError('formIF.servicios')" separator="." class="form-control" v-model="form.if.expenses.public_services"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Educación</label>
                            <vue-numeric  :max=999999999999999 tabindex="20" currency="$" autocomplete="off" name="educación" v-validate="modelValidations.sales" data-vv-id = "formIF.educación" :error="getError('formIF.educación')" separator="." class="form-control" v-model="form.if.expenses.education"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Salud</label>
                            <vue-numeric  :max=999999999999999 tabindex="21" currency="$" autocomplete="off" name="salud" v-validate="modelValidations.sales" data-vv-id = "formIF.salud" :error="getError('formIF.salud')" separator="." class="form-control" v-model="form.if.expenses.health"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Cuotas créditos recibidos por UF</label>
                            <vue-numeric  :max=999999999999999 tabindex="22" currency="$" autocomplete="off" name="cuotas" v-validate="modelValidations.sales" data-vv-id = "formIF.cuotas" :error="getError('formIF.cuotas')" separator="." class="form-control" v-model="form.if.expenses.credits"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Transporte</label>
                            <vue-numeric  :max=999999999999999 tabindex="23" currency="$" autocomplete="off" name="transporte" v-validate="modelValidations.sales" data-vv-id = "formIF.transporte" :error="getError('formIF.transporte')" separator="." class="form-control" v-model="form.if.expenses.transport"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Otros</label>
                            <vue-numeric  :max=999999999999999 tabindex="24" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="form.if.expenses.others"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Imprevistos * 10%</label>
                            <vue-numeric  :max=999999999999999 tabindex="25" currency="$" autocomplete="off" name="imprevistos" v-validate="modelValidations.sales" data-vv-id = "formIF.imprevistos" :error="getError('formIF.imprevistos')" separator="." class="form-control" v-model="family_expenses_incidentals_computed"></vue-numeric>
                        </div>
                        <div class="alert alert-warning mt-2">
                            <span>TOTAL EGRESOS UF: {{setFormat(family_expenses_computed)}}</span>
                        </div>
                        <div class="alert alert-success mt-2">
                            <span>EXCEDENTE: {{setFormat(family_surplus_computed)}}</span>
                        </div>
                    </div>
                </div> -->
                <div v-show="pyme" class="pyme-data">
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL EGRESOS UF: {{setFormat(family_expenses_computed)}}</span>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>EXCEDENTE: {{setFormat(family_surplus_computed)}}</span>
                    </div>
                </div>
                <!--Finaliza egresos personales, solo pyme-->
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formIF')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toER()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.b.locked" @submit.prevent="validateForm('formB')" data-vv-scope="formB">
            <card  id="toBElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Balance</h6>
                </div>
                <div class="card-body">
                    <h6 class="white">ACTIVO</h6>
                    <div class="form-group">
                        <label>Caja</label>
                        <vue-numeric  :max=999999999999999 tabindex="26" currency="$" autocomplete="off" name="caja" v-validate="modelValidations.sales" :error="getError('formB.caja')" separator="." class="form-control" v-model="form.b.assets.cash"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Bancos</label>
                        <vue-numeric  :max=999999999999999 tabindex="27" currency="$" autocomplete="off" name="bancos" v-validate="modelValidations.sales" :error="getError('formB.bancos')" separator="." class="form-control" v-model="form.b.assets.banks"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Cuentas ahorros/CDTs BMM</label>
                        <vue-numeric  :max=999999999999999 tabindex="28" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.saving_accounts"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Cuentas a cobrar a clientes</label>
                        <vue-numeric  :max=999999999999999 tabindex="29" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.accounts_receivable"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Inventarios</label>
                        <vue-numeric  :max=999999999999999 tabindex="30" currency="$" autocomplete="off" name="inventarios" v-validate="modelValidations.sales" :error="getError('formB.inventarios')" separator="." class="form-control" v-model="form.b.assets.inventory"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras cuentas de ahorro corriente</label>
                        <vue-numeric  :max=999999999999999 tabindex="31" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.others_accounts"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL ACTIVO CORRIENTE: {{setFormat(total_current_assets_computed)}}</span>
                    </div>
                    <!-- <div class="text-right">
                        <p-button @click="addEquipmentMethod()" type="info"><i class="mr-2 fa fa-plus"></i>Agregar</p-button>
                        <p-button @click="toI()" link type="default">Ir a inmuebles</p-button>
                    </div> -->
                    <div class="form-group">
                        <label>Inmuebles</label>
                        <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(1)"  tabindex="32" currency="$" autocomplete="off" name="inmuebles" v-validate="modelValidations.sales" :error="getError('formB.inmuebles')" separator="." class="form-control" v-model="form_estate_computed"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Muebles, maquinaria y equipo</label>
                        <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(2)" tabindex="33" currency="$" autocomplete="off" name="muebles" v-validate="modelValidations.sales" :error="getError('formB.muebles')" separator="." class="form-control" v-model="form_equipment_computed"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Vehículo</label>
                        <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(3)" tabindex="34" currency="$" autocomplete="off" name="vehículo" v-validate="modelValidations.sales" :error="getError('formB.vehículo')" separator="." class="form-control" v-model="form_vehicle_computed"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL ACTIVO FIJO: {{setFormat(total_fixed_assets_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Otros activos</label>
                        <vue-numeric  :max=999999999999999 tabindex="35" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" :error="getError('formB.otros')" separator="." class="form-control" v-model="form.b.assets.others_assets"></vue-numeric>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>TOTAL ACTIVO: {{setFormat(total_assets_computed)}}</span>
                    </div>
                    <h6 class="white">PASIVO</h6>
                    <div class="form-group">
                        <label>Cuentas por pagar a proveedores</label>
                        <vue-numeric  :max=999999999999999 tabindex="36" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.passives.accounts_payable_suppliers"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos bancarios/IMF para capital de trabajo</label>
                        <vue-numeric  :max=999999999999999 tabindex="37" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.banks_credits"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos BMM para capital de trabajo</label>
                        <vue-numeric  :max=999999999999999 tabindex="38" currency="$" autocomplete="off" name="créditos_BMM" v-validate="modelValidations.sales" :error="getError('formB.créditos_BMM')" separator="." class="form-control" v-model="form.b.passives.BMM_credits"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras obligaciones para capital de trabajo</label>
                        <vue-numeric  :max=999999999999999 tabindex="39" currency="$" autocomplete="off" name="obligaciones" v-validate="modelValidations.sales" :error="getError('formB.obligaciones')" separator="." class="form-control" v-model="form.b.passives.others_obligations"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO CORRIENTE: {{setFormat(total_current_passives_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Créditos bancarios para activo fijo</label>
                        <vue-numeric  :max=999999999999999 tabindex="40" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.banks_credits_fixed_assets"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos BMM/IMF para activo fijo</label>
                        <vue-numeric  :max=999999999999999 tabindex="41" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.BMM_credits_fixed_assets"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras obligaciones para activo fijo</label>
                        <vue-numeric  :max=999999999999999 tabindex="42" currency="$" autocomplete="off" name="obligaciones" v-validate="modelValidations.sales" :error="getError('formB.obligaciones')" separator="." class="form-control" v-model="form.b.passives.others_fixed_assets"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO NO CORRIENTE: {{setFormat(total_not_current_passives_computed)}}</span>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO DEL NEGOCIO: {{setFormat(total_business_passives_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Patrimonio</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="43" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.sales" :error="getError('formB.patrimonio')" separator="." class="form-control" v-model="patrimony_computed"></vue-numeric>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>TOTAL PASIVO y PATRIMONIO: {{setFormat(total_passive_patrimony_computed)}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button @click="validateForm('formB')" type="warning">Siguiente</p-button>
                        <p-button v-if="validateStudy()" @click="toIF()" type="default" class="pull-left mb-3">Atrás</p-button>
                        <p-button v-else @click="toER()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--Financial obligations-->
        <!--add financial obligation -->
        <modal :show.sync="addObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar obligación</h6>
                <div class="form-group">
                    <label>Acreedor *</label>
                    <fg-input   type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_name"
                                :error="getError('acreedor')"
                                v-model="obligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label># cuotas pendientes *</label>
                    <fg-input   type="number"
                                name="cuotas"
                                placeholder="cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_value"
                                :error="getError('cuotas')"
                                v-model="obligationNumberPayments">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addObligationToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!-- /add financial obligation -->
        <!-- edit financial obligation -->
        <modal :show.sync="editObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar obligación</h6>
                <div class="form-group">
                    <label>Acreedor *</label>
                    <fg-input   type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_name"
                                :error="getError('acreedor')"
                                v-model="obligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label># cuotas pendientes *</label>
                    <fg-input   type="number"
                                name="cuotas"
                                placeholder="cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_value"
                                :error="getError('cuotas')"
                                v-model="obligationNumberPayments">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editFamiliarObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar obligación familiar</h6>
                <div class="form-group">
                    <label>Crédito recibido *</label>
                    <fg-input   disabled
                                type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('acreedor')"
                                v-model="familiarObligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="familiarObligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Saldo *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="saldo" v-validate="modelValidations.obligation" :error="getError('saldo')" separator="." class="form-control" v-model="familiarObligationResidue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="familiarObligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('plazo')"
                                v-model="familiarObligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditFamiliarObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editFamiliarObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!-- /edit financial obligation -->
        <form v-if="!form.of.locked" @submit.prevent="validateForm('formOF')" data-vv-scope="formOF">
            <card  id="toOFElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Obligaciones financieras del negocio</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.of.business.obligations.length" :data="form.of.business.obligations"  ref="obligationsTable"  highlight-current-row @current-change="handleCurrentObligationChange">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p>Acreedor: {{ props.row.obligationCreditor }}</p>
                                <p>Monto: {{ setFormat(props.row.obligationAmount) }}</p>
                                <p>Valor cuota: {{ setFormat(props.row.obligationPaymentValue) }}</p>
                                <p># cuotas pendientes: {{ props.row.obligationNumberPayments }}</p>
                                <p>Plazo: {{ props.row.obligationTerm }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Acreedor" property="obligationCreditor"></el-table-column>
                        <el-table-column label="Monto">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationAmount)}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="Cuota">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationPaymentValue)}}</span>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <div>
                        <p-button 
                            @click="addObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar obligación
                        </p-button>
                        <br>
                        <p-button v-if="currentObligationRow"
                            @click="editObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar obligación
                        </p-button>
                        <br>
                        <p-button v-if="currentObligationRow"
                            @click="removeObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar obligación
                        </p-button>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formOF')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toB()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.of.familiar.locked" @submit.prevent="validateForm('formOFU')" data-vv-scope="formOFU">
            <card id="toOFUElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Obligaciones financieras de la unidad familiar</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.of.familiar.familiarObligations.length" :data="form.of.familiar.familiarObligations"  ref="familiarObligationsTable"  highlight-current-row @current-change="handleCurrentFamiliarObligationChange">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p>Créditos recibidos: {{ props.row.obligationCreditor }}</p>
                                <p>Monto: {{ setFormat(props.row.obligationAmount) }}</p>
                                <p>Saldo: {{ setFormat(props.row.obligationResidue) }}</p>
                                <p>Valor cuota: {{ setFormat(props.row.obligationPaymentValue) }}</p>
                                <p>Plazo: {{ props.row.obligationTerm }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Crédito" property="obligationCreditor"></el-table-column>
                        <!-- <el-table-column label="Monto">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationAmount)}}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Saldo">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationResidue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div>
                        <p-button v-if="currentFamiliarObligationRow"
                            @click="editFamiliarObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar obligación
                        </p-button>
                    </div>
                    <br>
                    <h6 class="orange">Patrimonio U.F.</h6>
                    <div class="form-group">
                        <label>Valor estimado Casa/Finca</label>
                        <vue-numeric  :max=999999999999999 tabindex="44" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.indebtness" :error="getError('patrimonio')" separator="." class="form-control" v-model="form.of.familiar.patrimonyHouse"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Valor estimado Vehículo</label>
                        <vue-numeric  :max=999999999999999 tabindex="45" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.indebtness" :error="getError('patrimonio')" separator="." class="form-control" v-model="form.of.familiar.patrimonyVehicle"></vue-numeric>
                    </div>
                    <div v-show="pyme" class="form-group">
                        <label>Valor ahorro / Inversiones</label>
                        <vue-numeric  :max=999999999999999 tabindex="46" currency="$" autocomplete="off" name="ahorro" v-validate="modelValidations.indebtness" :error="getError('ahorro')" separator="." class="form-control" v-model="form.of.familiar.patrimonySaving"></vue-numeric>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formOFU')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toOF()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!-- /Financial obligations-->
        <!-- Equipment  -->
        <!--add Equipment-->
        <modal :show.sync="addEquipment" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar</h6>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   ref="refEquipment"
                                type="text"
                                name="descripción"
                                placeholder="descripción"
                                autocomplete="off"
                                v-validate="modelValidations.equipment_name"
                                :error="getError('descripción')"
                                v-model="equipmentDescription">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="equipmentType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="equipmentType">
                            <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Inmueble">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Maquinaria/Equipo">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Vehículo">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.equipment_value" :error="getError('valor')" separator="." class="form-control" v-model="equipmentValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddEquipment()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addEquipmentToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Equipment-->
        <!--add Equipment-->
        <modal :show.sync="editEquipment" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar</h6>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   type="text"
                                name="descipción"
                                placeholder="descipción"
                                autocomplete="off"
                                v-validate="modelValidations.equipment_name"
                                :error="getError('descipción')"
                                v-model="equipmentDescription">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="equipmentType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="equipmentType">
                            <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Inmueble">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Maquinaria/Equipo">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Vehículo">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="equipmentValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditEquipment()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editEquipmentToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Equipment-->
        <!-- Incomes  -->
        <!--add Incomes-->
        <modal :show.sync="addIncomes" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar</h6>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="incomeType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="incomeType">
                            <!-- <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Bonificaciones y comisiones">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Microempresariales">
                            </el-option> -->
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Otros">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 ref="refIncomes" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.equipment_value" :error="getError('valor')" separator="." class="form-control" v-model="incomeValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddIncomes()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addIncomesToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Incomes-->
        <!--add Equipment-->
        <modal :show.sync="editIncomes" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar</h6>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="incomeType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="incomeType">
                            <!-- <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Bonificaciones y comisiones">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Microempresariales">
                            </el-option> -->
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Otros">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="incomeValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditIncomes()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editIncomesToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Equipment-->
        <!-- add Personal Expense -->
        <modal :show.sync="addPersonalExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar</h6>
            <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   type="text"
                                name="gasto"
                                placeholder="gasto"
                                autocomplete="off"
                                v-validate="modelValidations.equipment_name"
                                :error="getError('gasto')"
                                v-model="personalExpenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="personalExpenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddPersonalExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addPersonalExpenseToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!-- ./add Personal Expense --> 
        <!-- edit Personal Expense -->
        <modal :show.sync="editPersonalExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar</h6>
            <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   disabled
                                type="text"
                                name="gasto"
                                placeholder="gasto"
                                autocomplete="off"
                                v-validate="modelValidations.equipment_name"
                                :error="getError('gasto')"
                                v-model="personalExpenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="personalExpenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditPersonalExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editPersonalExpenseToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!-- ./edit Personal Expense --> 

        <form v-if="!form.i.equipment.locked" @submit.prevent="validateForm('formIF')" data-vv-scope="formIF">
            <card  id="toIElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Inmuebles/Muebles, maquinarias, equipos y vehículos del negocio</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.i.equipment.equipment.length" :data="form.i.equipment.equipment"  ref="equipmentsTable"  highlight-current-row @current-change="handleCurrentEquipmentChange">
                        <el-table-column label="Descripción" property="equipmentDescription"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.equipmentValue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div>
                        <p-button 
                            @click="addEquipmentMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar
                        </p-button>
                        <br>
                        <p-button v-if="currentEquipmentRow"
                            @click="editEquipmentMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar
                        </p-button>
                        <br>
                        <p-button v-if="currentEquipmentRow"
                            @click="removeEquipmentMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar
                        </p-button>
                    </div>
                    <!-- <p-button @click="toB()" link type="default">Ir a balance</p-button> -->
                </div>
                <div class="card-footer">
                    <div v-if="total_equipment_computed != 0" class="alert alert-warning mt-2">
                        <span>TOTAL: {{setFormat(total_equipment_computed)}}</span>
                    </div>
                    <div class="text-right">
                            <p-button @click="validateForm('formI')" class="btn btn-warning">Siguiente</p-button>
                            <p-button v-if="validateStudy()" @click="toOFU()" type="default" class="pull-left mb-3">Atrás</p-button>
                            <p-button v-else @click="toOF()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--./ Equipment-->
        <!-- Payment capacity-->
        <!--help-->
        <modal :show.sync="showHelp" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Información</h6>
            <div class="alert alert-warning mt-2">
                <span>Información de ayuda: {{helpText}}</span>
            </div>
            <template slot="footer">
                <p-button type="default" link @click="cancelHelp()">Cancelar</p-button>
            </template>
        </modal>
        <!--./ help-->
        <form v-if="!form.cp.locked" @submit.prevent="validateForm('formCP')" data-vv-scope="formCP">
            <card-orange  id="toCPElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Análisis de la capacidad de pago</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="payment_capacity_computed.length" :data="payment_capacity_computed" @row-dblclick="showHelpMethod" ref="paymentCapacityTable" :row-class-name="tableRowClassName2">
                        <el-table-column label="Variable" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.value)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formCP')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toI()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card-orange>
        </form>
        <!--./ Payment capacity-->
        <!--Financial indicators-->
        <form v-if="!form.i.locked" @submit.prevent="validateForm('formIFI')" data-vv-scope="formIFI">
            <card  id="toIFIElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Ingresos por actividades ordinarias anuales</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Ingreso por ventas al contado * 12</label>
                        <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.sales" data-vv-id = "formIFI.ingresos" :error="getError('formIFI.ingresos')" separator="." class="form-control" v-model="form.ao.incomes"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Fecha de corte fiscal</label>
                        <el-date-picker
                            format="dd/MM/yyyy"
                            v-model="form.ao.date"
                            type="date"
                            placeholder="Seleccione fecha de corte">
                        </el-date-picker>
                    </div>
                </div>
                <div class="card-header">
                    <h6 class="card-title-orange">Indicadores financieros</h6>
                </div>
                <div v-if="agro" class="card-body">
                    <el-table v-if="form.i.financialIndicators.length" :data="form.i.financialIndicators"  @row-dblclick="showHelpMethod" ref="financialIndicatorsTable" :row-class-name="tableRowClassName">
                        <el-table-column label="Indicador" property="name"></el-table-column>
                        <el-table-column label="Alerta">
                            <template slot-scope="scope">
                                <span >{{ scope.row.alert }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setSuffix(scope.row)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <br>
                    <div class="form-group">
                        <label>Fuente alternativa de pagos y gastos estacionales</label>
                        <textarea
                            maxlength="40"
                            class="form-control"
                            name="fuente alternativa"
                            autocomplete="off"
                            @input="validateInput"
                            v-model="form.i.agroDataSourcePaymentData">
                        </textarea>
                    </div>

                </div>
                <div v-else class="card-body">
                    <el-table v-if="form.i.financialIndicators.length" :data="form.i.financialIndicators"  @row-dblclick="showHelpMethod" ref="financialIndicatorsTable" :row-class-name="tableRowClassName">
                        <el-table-column label="Indicador" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setSuffix(scope.row)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formIFI')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toCP()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--./Financial indicators-->
        <fab
        :position="position"
        :bg-color="bgColor"
        :actions="fabActions"
        main-icon='search'
        icon-size="small"
        @toER="toER"
        @toIF="toIF"
        @toB="toB"
        @toOF="toOF"
        @toOFU="toOFU"
        @toI="toI"
        @toCP="toCP"
        @toIFI="toIFI"
        ></fab>
    </div>
</template>
<script>
import Vue from 'vue'
import swal from 'sweetalert2'
import fab from 'vue-fab'
import VueScrollTo from 'vue-scrollto'
import VueNumeric from 'vue-numeric'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import { Modal } from 'src/components/UIComponents'
import {Select, Option, Table, TableColumn, DatePicker, TimeSelect} from 'element-ui'
import FinancialIndicators from 'src/util/FinancialIndicators/FinancialIndicators'
import FinancialIndicatorsAgro from 'src/util/FinancialIndicators/FinancialIndicatorsAgro'
import PaymentCapacity from 'src/util/PaymentCapacity/PaymentCapacity'
import PaymentCapacityPyme from 'src/util/PaymentCapacity/PaymentCapacityPyme'
import expr from 'expression-eval'
import moment from 'moment'
import { isEmpty } from 'lodash';
import FinancialObligations from './FinancialObligations.vue'
import { Validator } from 'vee-validate';

Validator.localize('es', {
  attributes: {
    'formIF.alimentación': 'alimentación'
  }
});

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
// You can also pass in the default options
Vue.use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
})
export default {
    components: {
        fab,
        VueNumeric,
        Modal,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
    },
    data(){
        return {
            financialIndicatorAgro1: 0,
            financialIndicatorAgro2: 0,
            fm102quota: null,
            consumer: false,
            microcredit: false,
            pyme: false,
            agro: false,
            modifiedFinancialIndicators: true,
            showHelp: false,
            helpText: null,
            financialIndicators: [],
            currentObligationRow: null,
            currentPersonalExpenseRow: null,
            currentEquipmentRow: null,
            currentIncomesRow: null,
            currentFamiliarObligationRow: null,
            obligations: [],
            familiarObligations: [{
                obligationCreditor: 'T. de crédito',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            },
            {
                obligationCreditor: 'Cred. consumo',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            },
            {
                obligationCreditor: 'Cred. vivienda',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            }],
            addFamiliarObligation: false,
            editFamiliarObligation: false,
            addObligation: false,
            editObligation: false,
            addPersonalExpense: false,
            editPersonalExpense: false,
            addEquipment: false,
            editEquipment: false,
            equipmentDescription: '',
            equipmentType: '1',
            equipmentValue: '',
            addIncomes: false,
            editIncomes: false,
            incomeType: '3',
            incomeValue: '',
            personalExpenseName: '',
            personalExpenseValue: '',
            familiarObligationCreditor: '',
            familiarObligationAmount: '',
            familiarObligationPaymentValue: '',
            familiarObligationResidue: '',
            familiarObligationTerm: '',
            obligationCreditor: '',
            obligationAmount: '',
            obligationPaymentValue: '',
            obligationNumberPayments: '',
            obligationTerm: '',
            bgColor: '#F09500',
            position: 'bottom-right',
            position2: 'top-right',
            fabActions: [
                {
                    name: 'toER',
                    icon: 'ER'
                },
            ],
            fabActions2: [
                {
                    name: 'toER',
                    icon: 'ER'
                },
                {
                    name: 'toIF',
                    icon: 'IF'
                },
                {
                    name: 'toB',
                    icon: 'B'
                },
                {
                    name: 'toOF',
                    icon: 'OF'
                },
                {
                    name: 'toOFU',
                    icon: 'OFU'
                },
                {
                    name: 'toI',
                    icon: 'I'
                },
                {
                    name: 'toCP',
                    icon: 'CP'
                },
                {
                    name: 'toIFI',
                    icon: 'IFI'
                },
                
            ],
            form: {
                indebtness: '', //Endeudamiento
                debt: { //Tipo de cartera
                    cial: false,
                    mc: true
                },
                er: { //er: estado de resultados
                    locked: false, 
                    employees: 0, //número de empleados
                    account_sales: '', //ventas al contado
                    credit_sales: '', //recuperación de ventas a crédito
                    sales_costs: '', //costo de ventas
                    gross_profit: '', // utilidad bruta
                    net_profit: '', //utilidad neta
                    operative_expenses: { //gastos operativos
                        salaries: {
                            value: '',
                            locked: false
                        }, //salarios
                        rental: {
                            value: '',
                            locked: false
                        },  //alquiler
                        public_services: {
                            value: '',
                            locked: false
                        },  //servicios públicos
                        taxes: {
                            value: '',
                            locked: false
                        },  //impuestos
                        transport: {
                            value: '',
                            locked: false
                        },  //transporte
                        financial_expenses: {
                            value: '',
                            locked: false
                        },  //gastos financieros
                        others: {
                            value: '',
                            locked: false
                        },  //otros
                        incidentals: {
                            value: '',
                            locked: false
                        },  //imprevistos
                        total: '' //total
                    }
                },
                if: { //ingresos familiares
                    locked: true,
                    surplus: '', //excedente
                    incomes: { //ingresos
                        business_income: '', //ingresos del negocio
                        titular_salary: '', //salario del titular
                        spouse_salary: '', //salario conyuge
                        others: '', // otros ingresos netos
                        total: '' //total
                    },
                    personalExpenses: [ //Egresos personales - Pyme
                        {
                            personalExpenseName: 'Alquiler',
                            personalExpenseValue: '',
                            lock: true,
                            editable: true
                        },
                        {
                            personalExpenseName: 'Cuotas créditos recibidos por la UF',
                            personalExpenseValue: '',
                            lock: true,
                            editable: false
                        },
                        {
                            personalExpenseName: 'Otros Gastos',
                            personalExpenseValue: '',
                            lock: true,
                            editable: false
                        },
                        {
                            personalExpenseName: 'Imprevistos',
                            personalExpenseValue: '',
                            lock: true,
                            editable: false
                        }
                    ],
                    otherIncomes: [],
                    expenses: { //egresos
                        rental: '', //alquiler
                        feeding: '', //alimentación
                        public_services: '', //servicios públicos
                        education: '', //educación
                        health: '', //salud
                        credits: '', //cuotas créditos
                        transport: '', //transporte
                        others: '', //otros
                        incidentals: '', //imprevistos
                        total: '' //total
                    }   
                },
                b: {
                    locked: true,
                    assets: { //activos
                        cash: '', //caja
                        banks: '', //bancos
                        saving_accounts: '', //cuentas de ahorros
                        accounts_receivable: '', //cuentas a cobrar
                        inventory: '', //inventario
                        others_accounts: '', //otras cuentas de ahorro corrientes
                        total_current_assets: '', //total activos corrientes
                        estate: '', //inmuebles
                        equipment: '', //muebles, maquinaria
                        vehicle: '', //vehículo
                        total_fixed_assets: '', //total activos fijos
                        others_assets: '', //otros activos
                        total_assets: '' //total activos
                    },
                    passives: { //pasivos
                        accounts_payable_suppliers: '', //cuentas por pagar a proveedores
                        banks_credits: '', //créditos bancarios
                        BMM_credits: '', //créditos BMM
                        others_obligations: '', //otras obligaciones para capital de trabajo
                        total_current_passives: '', //total pasivos corrientes
                        banks_credits_fixed_assets: '', //créditos bancarios para activo fijo
                        BMM_credits_fixed_assets: '', //créditos BMM para activo fijo
                        others_fixed_assets: '', //otras obligaciones para activo fijo
                        total_not_current_passives: '', //total pasivos no corrientes
                        total_business_passives: '', //total pasivos del negocio
                        patrimony: '', //patrimonio
                        total_passive_patrimony: '' //total pasivo y patrimonio
                    }
                },
                of: { //obligaciones financieras
                    locked: true,
                    business: { //obligaciones financieras del negocio
                        obligations:[],
                    },
                    familiar: { //obligaciones familiares
                        locked: true,
                        familiarObligations: [{
                            obligationCreditor: 'Tarjeta de crédito', //Acreedor
                            obligationAmount: '', //monto
                            obligationResidue: '', //saldo
                            obligationPaymentValue: '', //valor cuota
                            obligationTerm: 0, //plazo
                        },
                        {
                            obligationCreditor: 'Crédito consumo',
                            obligationAmount: '',
                            obligationResidue: '',
                            obligationPaymentValue: '',
                            obligationTerm: 0,
                        },
                        {
                            obligationCreditor: 'Crédito vivienda',
                            obligationAmount: '',
                            obligationResidue: '',
                            obligationPaymentValue: '',
                            obligationTerm: 0,
                        }],
                        patrimonyHouse: 0, //valor estimado casa/finca
                        patrimonyVechicle: 0, //valor estimado vehículo
                        patrimonySaving: 0 //valor ahorro e inversiones
                    }
                    
                    
                },
                ao: { //actividades ordinarias
                    incomes: '',
                    date: null,
                },
                i: { //inmuebles, equipos
                    equipment: { //equipos
                        locked: true,
                        equipment: [],
                        total: 0 //total de equipos
                    },
                    locked: true,
                    agroDataSourcePaymentData : '',
                    financialIndicators: [] //indicadores financieros
                },
                cp: { //capacidad de pago
                    locked: true,
                    paymentCapacity: [] 
                }
            },
            
            modelValidations: {
                indebtness: {
                    required: false
                },
                employees: {
                    required: false,
                    numeric: true
                },
                salesTrue: {
                    required: true
                },
                sales: {
                    required: false
                },
                obligation_value: {
                    required: false
                },
                obligation_term: {
                    required: false,
                    max: 32
                },
                obligation_name: {
                    required: false,
                    max: 32
                },
                equipment_name: {
                    required: false,
                    max: 64
                },
                equipment_value: {
                    required: false
                },
                textArea: {
                    max: 40,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                }
            },
        }
    },
    computed: {
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        incomes_others_computed: {
            get () {
                var sum = 0;
                for (let i=0;i<this.form.if.otherIncomes.length;i++) {
                    sum = sum + parseFloat(this.form.if.otherIncomes[i].incomeValue);
                }
                this.form.if.incomes.others = sum;
                return sum;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        form_estate_computed : {
            get () {
                if(!this.agro){
                    var sum_estate= 0;
                    for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                        if (this.form.i.equipment.equipment[i].equipmentType == '1') {
                            sum_estate = sum_estate + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                        }
                    }
                    this.form.b.assets.estate = sum_estate;
                    return sum_estate;
                }
                else {
                    return this.form.b.assets.estate;
                }
            },
            set (value) {
                this.form.b.assets.estate = value;
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        form_equipment_computed : {
            get () {
                if(!this.agro){
                    var sum_equipment= 0;
                    for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                        if (this.form.i.equipment.equipment[i].equipmentType == '2') {
                            sum_equipment = sum_equipment + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                        }
                    }
                    this.form.b.assets.equipment = sum_equipment;
                    return sum_equipment;
                }
                else {
                    return this.form.b.assets.equipment;
                }
            },
            set (value) {
                this.form.b.assets.equipment = value;
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        form_vehicle_computed : {
            get () {
                
                var sum_vehicle= 0;
                for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                    if (this.form.i.equipment.equipment[i].equipmentType == '3') {
                        sum_vehicle = sum_vehicle + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                    }
                }
                this.form.b.assets.vehicle = sum_vehicle;
                return sum_vehicle;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_equipment_computed: {
            get () {
                var sum = 0;
                for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                    sum = sum + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                }
                return sum;
            },
            set () {
                
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_passive_patrimony_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_passive_patrimony = parseFloat(this.patrimony_computed) + parseFloat(this.total_business_passives_computed);
                total = this.form.b.passives.total_passive_patrimony;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        patrimony_computed: {
            get () {
                var total = 0;
                this.form.b.passives.patrimony = parseFloat(this.total_assets_computed || 0) - parseFloat(this.total_business_passives_computed || 0);
                total = this.form.b.passives.patrimony;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_business_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_business_passives = parseFloat(this.total_not_current_passives_computed  || 0) + parseFloat(this.total_current_passives_computed || 0);
                total = this.form.b.passives.total_business_passives;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_not_current_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_not_current_passives = parseFloat(this.form.b.passives.banks_credits_fixed_assets || 0) + parseFloat(this.form.b.passives.BMM_credits_fixed_assets || 0) + parseFloat(this.form.b.passives.others_fixed_assets || 0);
                total = this.form.b.passives.total_not_current_passives;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_current_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_current_passives = parseFloat(this.form.b.passives.accounts_payable_suppliers || 0) + parseFloat(this.form.b.passives.banks_credits || 0) + parseFloat(this.form.b.passives.BMM_credits || 0) + parseFloat(this.form.b.passives.others_obligations || 0);
                total = this.form.b.passives.total_current_passives;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_assets = parseFloat(this.form.b.assets.others_assets || 0) + parseFloat(this.total_fixed_assets_computed || 0) + parseFloat(this.total_current_assets_computed || 0);
                total = this.form.b.assets.total_assets;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_fixed_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_fixed_assets = parseFloat(this.form.b.assets.estate  || 0) + parseFloat(this.form.b.assets.equipment || 0) + parseFloat(this.form.b.assets.vehicle || 0);
                total = this.form.b.assets.total_fixed_assets;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_current_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_current_assets = parseFloat(this.form.b.assets.cash || 0) + parseFloat(this.form.b.assets.banks || 0) + parseFloat(this.form.b.assets.saving_accounts || 0) + parseFloat(this.form.b.assets.accounts_receivable || 0) + parseFloat(this.form.b.assets.inventory || 0) + parseFloat(this.form.b.assets.others_accounts || 0);
                total = this.form.b.assets.total_current_assets;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        gross_profit_computed: {
            get () {
                var total = 0;
                this.form.er.gross_profit = parseFloat(this.form.er.account_sales) + parseFloat(this.form.er.credit_sales) - parseFloat(this.form.er.sales_costs);
                total = this.form.er.gross_profit; 
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        operative_expenses_computed: {
            get () {
                var total = 0;
                // this.form.er.operative_expenses.total = parseFloat(this.form.er.operative_expenses.salaries.value || 0) + parseFloat(this.form.er.operative_expenses.rental.value  || 0) + parseFloat(this.form.er.operative_expenses.public_services.value  || 0) + parseFloat(this.form.er.operative_expenses.taxes.value  || 0) + parseFloat(this.form.er.operative_expenses.transport.value  || 0) + parseFloat(this.form.er.operative_expenses.financial_expenses.value || 0) + parseFloat(this.form.er.operative_expenses.others.value  || 0) + parseFloat(this.form.er.operative_expenses.incidentals.value || 0);
                this.form.er.operative_expenses.total = parseFloat(
                (
                    parseFloat(this.form.er.operative_expenses.salaries.value || 0) +
                    parseFloat(this.form.er.operative_expenses.rental.value || 0) +
                    parseFloat(this.form.er.operative_expenses.public_services.value || 0) +
                    parseFloat(this.form.er.operative_expenses.taxes.value || 0) +
                    parseFloat(this.form.er.operative_expenses.transport.value || 0) +
                    parseFloat(this.form.er.operative_expenses.financial_expenses.value || 0) +
                    parseFloat(this.form.er.operative_expenses.others.value || 0) +
                    parseFloat(this.form.er.operative_expenses.incidentals.value || 0)
                ).toFixed(1) // Redondea a 2 decimales y devuelve un string
                );
                var total = this.form.er.operative_expenses.total;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        net_profit_computed: {
            get () {
                if(!this.$store.state.isSpouse){
                    var total = 0;
                    this.form.er.net_profit = parseFloat(this.gross_profit_computed) - parseFloat(this.operative_expenses_computed);
                    this.form.if.incomes.business_income = this.form.er.net_profit;
                    total = this.form.er.net_profit;
                    return total;
                }
                else {
                    if(this.pyme){
                        var total = 0;
                        this.form.er.net_profit = parseFloat(this.gross_profit_computed) - parseFloat(this.operative_expenses_computed);
                        this.form.if.incomes.business_income = this.form.er.net_profit;
                        total = this.form.er.net_profit;
                        return total;
                    }
                    else if(this.agro) {
                        this.form.if.incomes.business_income = 0;
                        return 0;
                    }
                    else {
                        var total = 0;
                        this.form.er.net_profit = parseFloat(this.gross_profit_computed) - parseFloat(this.operative_expenses_computed);
                        this.form.if.incomes.business_income = this.form.er.net_profit;
                        total = this.form.er.net_profit;
                        return total;
                    }
                }
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_income_computed: {
            get () {
                var total = 0;
                this.form.if.incomes.total = parseFloat(this.form.if.incomes.business_income || 0) + parseFloat(this.form.if.incomes.titular_salary || 0) + parseFloat(this.form.if.incomes.spouse_salary || 0) + parseFloat(this.form.if.incomes.others || 0); 
                total = this.form.if.incomes.total;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_expenses_incidentals_computed: {
            get () {
                if(!this.agro){
                    var total = 0;
                    this.form.if.expenses.incidentals = parseFloat(this.family_income_computed) * 10 / 100;
                    total = this.form.if.expenses.incidentals;
                    return total;
                }
                else {
                    var total = 0;
                    this.form.if.expenses.incidentals = parseFloat(this.form.if.expenses.total) * 20 / 100;
                    total = this.form.if.expenses.incidentals;
                    return total;
                }
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_expenses_computed: {
            get () {
                if(!this.pyme){
                    var total = 0;
                    this.form.if.expenses.total = parseFloat(this.form.if.expenses.rental || 0) + parseFloat(this.form.if.expenses.feeding  || 0) + parseFloat(this.form.if.expenses.public_services  || 0) + parseFloat(this.form.if.expenses.education  || 0) + parseFloat(this.form.if.expenses.health  || 0) + parseFloat(this.form.if.expenses.credits  || 0) + parseFloat(this.form.if.expenses.transport  || 0) + parseFloat(this.form.if.expenses.others  || 0) + parseFloat(this.form.if.expenses.incidentals  || 0);
                    total = this.form.if.expenses.total;
                    return total;
                }
                else {
                    var total = 0;
                    this.form.if.expenses.total = this.form.if.personalExpenses.reduce((sum, expense) => 
                        sum + ((expense.lock ? expense.personalExpenseValue : 0) || 0), 0);
                    total = this.form.if.expenses.total;
                    return total;
                }
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_surplus_computed: {
            get () {
                var total = 0;
                if(this.agro){
                    this.form.if.surplus = parseFloat(this.gross_profit_computed || 0) - parseFloat(this.family_expenses_computed || 0);
                }
                else {
                    this.form.if.surplus = parseFloat(this.family_income_computed || 0) - parseFloat(this.family_expenses_computed || 0);
                }
                total = this.form.if.surplus;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        payment_capacity_computed: {
            get () {
                if (this.$store.state.isCustomer) {
                    for (let i=0;i<this.form.cp.paymentCapacity.length;i++) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy > 0) {
                            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].productType);
                            if (product.name.toLowerCase() == 'consumo') {
                                this.form.cp.paymentCapacity[i].value = 0;
                            }
                            else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                                var evalResult = 0;
                                evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                                this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                            }
                            else if (product.name.toLowerCase() == 'pequeña empresa') {
                                // var evalResult = 0;
                                // evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                                // this.form.cp.paymentCapacity[i].value = evalResult || 0; 
                                if(this.form.cp.paymentCapacity[i].id == 5){
                                    this.form.cp.paymentCapacity[i].value = this.form.if.surplus*0.75;
                                }
                                if(this.form.cp.paymentCapacity[i].id == 6){
                                    this.form.cp.paymentCapacity[i].value = this.form.if.incomes.total;
                                }
                                if(this.form.cp.paymentCapacity[i].id == 7){
                                    this.form.cp.paymentCapacity[i].value = this.form.if.expenses.total;
                                }
                                if(this.form.cp.paymentCapacity[i].id == 8){
                                    this.form.cp.paymentCapacity[i].value = this.form.if.surplus;
                                }       
                            }
                        }
                        else {
                            var evalResult = 0;
                            evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                            this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                        }
                        
                    }
                }
                else if(this.$store.state.isSpouse) {
                    for (let i=0;i<this.form.cp.paymentCapacity.length;i++) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy > 0) {
                            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].productType);
                            if (product.name.toLowerCase() == 'consumo') {
                                this.form.cp.paymentCapacity[i].value = 0;
                            }
                            else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                                var evalResult = 0;
                                evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                                this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                            }
                            else if (product.name.toLowerCase() == 'pequeña empresa') {
                                var evalResult = 0;
                                evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                                this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                            }
                        }
                        else {
                            var evalResult = 0;
                            evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                            this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                        }
                        
                    }
                }
                else if (this.$store.state.isGuarantor) {
                    for (let i=0;i<this.form.cp.paymentCapacity.length;i++) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1 > 0) {
                            var product = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType;
                            if (product.name.toLowerCase() == 'consumo') {
                                this.form.cp.paymentCapacity[i].value = 0;
                            }
                            else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                                var evalResult = 0;
                                evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                                this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                            }
                            else if (product.name.toLowerCase() == 'pequeña empresa') {
                                var evalResult = 0;
                                evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                                this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                            }
                        }
                        else {
                            var evalResult = 0;
                            evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                            this.form.cp.paymentCapacity[i].value = evalResult || 0;        
                        }
                        
                    }
                }
                return this.form.cp.paymentCapacity;
            },
            set () {

            }
        }
    },
    watch: {
        family_income_computed: function(newVal){
            this.updatePersonalExpensesAnotherExpenses();
        },
        total_assets_computed: function(newVal) {
            this.determineCreditType(newVal);
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        'form.er.employees': function (newVal) {
            this.form.er.employees =  parseFloat(newVal)
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        'form.debt.cial': function (newVal, oldVal) {
            if (newVal) {
                this.form.debt.mc = false;
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        'form.debt.mc': function (newVal, oldVal) {
            if (newVal) {
                this.form.debt.cial = false;
            }
        },
        },
    methods:{
        setCashFlowBalance(dataConsolidated){
            let vm = this;
            vm.$store.dispatch('setCashFlowBalance', dataConsolidated).then(()=>{
                console.log('Información almacenada satisfactoriamente');
            });
        },
        validateInput(event) {
            // Permite solo letras, números y espacios
            this.form.i.agroDataSourcePaymentData = event.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]/g, '');
        },
       /**
         * Updates specific personal expenses based on calculated totals.
         * @param {number} family_income_computed - The computed family income to add to total.
         */
        // updatePersonalExpensesAnotherExpenses() {
        //     if(this.$store.state.isCustomer){
        //         if(currentAssessment.customer.actualStudy == 0){
        //             // Suma los valores de personalExpenses que no están bloqueados y no son "Otros Gastos"
        //             const total = this.form.if.personalExpenses
        //                 .filter(expense => !expense.lock && expense.personalExpenseName !== 'Otros Gastos')
        //                 .reduce((sum, expense) => sum + expense.personalExpenseValue, 0);

        //             // Actualiza "Otros Gastos" y "Imprevistos" con los porcentajes correspondientes
        //             this.form.if.personalExpenses.forEach(expense => {
        //                 if (expense.personalExpenseName === 'Otros Gastos') {
        //                     expense.personalExpenseValue = total + (this.family_income_computed * 0.15) || 0;
        //                 } else if (expense.personalExpenseName === 'Imprevistos') {
        //                     expense.personalExpenseValue = this.family_income_computed * 0.05 || 0;
        //                 }
        //             });
        //         }
        //     }
        //     else if(this.$store.state.isSpouse){
        //         if(currentAssessment.customerSpouse.actualStudy == 0){
        //             // Suma los valores de personalExpenses que no están bloqueados y no son "Otros Gastos"
        //             const total = this.form.if.personalExpenses
        //                 .filter(expense => !expense.lock && expense.personalExpenseName !== 'Otros Gastos')
        //                 .reduce((sum, expense) => sum + expense.personalExpenseValue, 0);

        //             // Actualiza "Otros Gastos" y "Imprevistos" con los porcentajes correspondientes
        //             this.form.if.personalExpenses.forEach(expense => {
        //                 if (expense.personalExpenseName === 'Otros Gastos') {
        //                     expense.personalExpenseValue = total + (this.family_income_computed * 0.15) || 0;
        //                 } else if (expense.personalExpenseName === 'Imprevistos') {
        //                     expense.personalExpenseValue = this.family_income_computed * 0.05 || 0;
        //                 }
        //             });
        //         }
        //     }
        //     else if(this.$store.state.isGuarantor){
        //         if(currentAssessment.guarantors[currentAssessment.actualGuarantors].actualStudy == 0){
        //             // Suma los valores de personalExpenses que no están bloqueados y no son "Otros Gastos"
        //             const total = this.form.if.personalExpenses
        //                 .filter(expense => !expense.lock && expense.personalExpenseName !== 'Otros Gastos')
        //                 .reduce((sum, expense) => sum + expense.personalExpenseValue, 0);

        //             // Actualiza "Otros Gastos" y "Imprevistos" con los porcentajes correspondientes
        //             this.form.if.personalExpenses.forEach(expense => {
        //                 if (expense.personalExpenseName === 'Otros Gastos') {
        //                     expense.personalExpenseValue = total + (this.family_income_computed * 0.15) || 0;
        //                 } else if (expense.personalExpenseName === 'Imprevistos') {
        //                     expense.personalExpenseValue = this.family_income_computed * 0.05 || 0;
        //                 }
        //             });
        //         }
        //     }
        // },
        /**
         * Updates specific personal expenses based on calculated totals.
         */
         updatePersonalExpensesAnotherExpenses() {
            const isEligibleForUpdate = (studyStatus) => studyStatus === 0;

            const calculateAndUpdateExpenses = () => {
                if(!this.$store.state.isSpouse){
                    // Calculate the total of unlocked personal expenses excluding "Otros Gastos"
                    const total = this.form.if.personalExpenses
                        .filter(expense => !expense.lock && expense.personalExpenseName !== 'Otros Gastos')
                        .reduce((sum, expense) => sum + expense.personalExpenseValue, 0);

                    // Update "Otros Gastos" and "Imprevistos" values
                    this.form.if.personalExpenses.forEach(expense => {
                        if (expense.personalExpenseName === 'Otros Gastos') {
                            expense.personalExpenseValue = total + (this.family_income_computed * 0.15) || 0;
                        } else if (expense.personalExpenseName === 'Imprevistos') {
                            expense.personalExpenseValue = this.family_income_computed * 0.05 || 0;
                        }
                    });
                }
            };
            const currentAssessment = this.$store.state.assesments[this.$store.state.actualAssesment];
            if (this.$store.state.isCustomer) {
                if (isEligibleForUpdate(currentAssessment.customer.actualStudy)) {
                    calculateAndUpdateExpenses();
                }
            } else if (this.$store.state.isSpouse) {
                if (isEligibleForUpdate(currentAssessment.customerSpouse.actualStudy)) {
                    calculateAndUpdateExpenses();
                }
            } else if (this.$store.state.isGuarantor) {
                const guarantor = currentAssessment.guarantors[currentAssessment.actualGuarantors];
                if (isEligibleForUpdate(guarantor.actualStudy)) {
                    calculateAndUpdateExpenses();
                }
            }
        },

        determineCreditType(assets) {
            const salary = this.$store.state.salary; // 1 SMLV
            const indebtness = this.form.indebtness;

            // Calculamos los límites de 120 SMLV y 501 SMLV
            const limiteIndebtness = 120 * salary;
            const limiteActivos = 501 * salary;

            // Comparar valores con las reglas de la tabla
            if (indebtness <= limiteIndebtness) {
            if (assets < limiteActivos) {
                this.form.debt.cial = false;
                this.form.debt.mc = true;

            } else {
                this.form.debt.cial = true;
                this.form.debt.mc = false;
            }
            } else if (indebtness > limiteIndebtness) {
                this.form.debt.cial = true;
                this.form.debt.mc = false;
            }

        },
        /**
         * 
         * This function adds one to its input.
         * @param {number} input any number
         * @returns {number} that number, plus one.
         */
        updateObligationResidue(totalObligationsCAV) {
            // Busca la obligación con obligationCreditor igual a 'Cred. vivienda'
            this.form.of.familiar.familiarObligations.forEach(obligation => {
                if (obligation.obligationCreditor === 'Crédito vivienda') {
                    // Establece el valor de obligationResidue como totalObligationsCAV
                    obligation.obligationResidue = totalObligationsCAV;
                }
            });
        },
        /**
         * 
         * This function adds one to its input.
         * @param {number} input any number
         * @returns {number} that number, plus one.
         */
        sumObligations(obligations) {
            let totalResidue = 0;
            let totalQuota = 0;

            obligations.forEach(obligation => {
                // Sumar obligationResidue si está definido
                totalResidue += parseFloat(obligation.obligationResidue) || 0;

                // Sumar obligationQuota si está definido
                totalQuota += parseFloat(obligation.obligationQuota) || 0;
            });

            return {
                totalResidue,
                totalQuota
            };
        },
        /**
         * This function adds one to its input.
         * @param {number} input any number
         * @returns {number} that number, plus one.
         */
        filterAndSumQuotasByType(obligations, typesToFilter) {
            return typesToFilter.reduce((acc, type) => {
                // Filtramos las obligaciones por el tipo deseado
                const filteredObligations = obligations.filter(obligation => obligation.obligationType === type && obligation.obligationCollect === "No");

                // Inicializamos la suma de cuotas
                let totalQuota = 0;

                // Recorremos las obligaciones filtradas y sumamos el mayor valor de quota o quotaCreditFlow
                filteredObligations.forEach(obligation => {
                const maxQuota = Math.max(obligation.obligationQuota || 0, obligation.obligationQuotaCreditFlow || 0);
                totalQuota += maxQuota;
                });

                // Guardamos el total por tipo
                acc[type] = totalQuota;
                return acc;
            }, {});
        },
        /**
         * This function adds one to its input.
         * @param {number} input any number
         * @returns {number} that number, plus one.
         */
        filterAndSumObligationsByType(obligations, typesToFilter) {
            return typesToFilter.reduce((acc, type) => {
                // Filtramos las obligaciones por el tipo deseado
                const filteredObligations = obligations.filter(obligation => obligation.obligationType === type);
                // Inicializamos las sumas para cada destino
                const result = {
                capitalTrabajoResidue: 0,
                activoFijoResidue: 0
                };

                // Recorremos las obligaciones filtradas
                filteredObligations.forEach(obligation => {
                    let maxResidue = 0;

                    // Si obligationCollect es "No", se elige el mayor valor entre Residue y ResidueCreditFlow
                    if (obligation.obligationCollect === "No") {
                        maxResidue = Math.max(obligation.obligationResidue || 0, obligation.obligationResidueCreditFlow || 0);
                    } 
                    // Si obligationCollect es "Si", solo usamos Residue, ignorando ResidueCreditFlow
                    else {
                        maxResidue = obligation.obligationResidue || 0;
                    }
                    // Sumar a la categoría de destino correspondiente
                    if (obligation.obligationCreditDestiny === "Capital de trabajo") {
                        result.capitalTrabajoResidue += maxResidue;
                    } else if (obligation.obligationCreditDestiny === "Activo fijo") {
                        result.activoFijoResidue += maxResidue;
                    }
                });

                acc[type] = result;
                return acc;
            }, {});
        },
        /**
         * This function adds one to its input.
         * @param {number} input any number
         * @returns {number} that number, plus one.
         */
        productValidator (product) {
            if (product.name.toLowerCase() == 'consumo') {
                this.consumer = true;
                this.microcredit = false;
                this.pyme = false;
                this.agro = false;
            }
            else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                this.microcredit = true;
                this.consumer = false;
                this.pyme = false;
                this.agro = false;
            }
            else if (product.name.toLowerCase() == 'pequeña empresa') {
                this.microcredit = false;
                this.consumer = false;
                this.pyme = true;
                this.agro = false;
            }
            else if (product.name.toLowerCase() == 'agropecuario') {
                // this.showNotificationError('Ha ocurrido un problema con la información de crédito agropecuario. Consulta con soporte técnico');
                this.microcredit = false;
                this.consumer = false;
                this.pyme = false;
                this.agro = true;
            }
            else {
                this.consumer = false;
                this.microcredit = false;
                this.pyme = false;
                this.agro = false;
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        otherIncomesFocus(){
            var vm = this;
            let promise = new Promise(function(resolve, reject) {
                vm.incomeType = '3';
                vm.addIncomesMethod();
                resolve();
            }).then(function(resolve){
                document.getElementById("otherIncomes").blur();
                // vm.$refs.refIncomes.$el.children[0].focus()
            });
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        equipmentFocus(index){
            var vm = this;
            if(vm.form.i.equipment.equipment.length < 5) {
                let promise = new Promise(function(resolve, reject) {
                    vm.equipmentType = index.toString();
                    vm.addEquipmentMethod();
                    resolve();
                }).then(function(resolve){
                    vm.$refs.refEquipment.$el.children[0].focus()
                });
            }
            else {
                this.showNotificationError('El máximo número de de inmuebles, maquinaria y equipo es 5');
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        validateOperatingExpensesDisabled (val) {
            if (val == 0) {
                return false
            }
            else {
                return true
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        validateStudy () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                    return true
                }
                else {
                    return false
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy == 0) {
                    return true
                }
                else {
                    return false
                }
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1 == 0) {
                    return true
                }
                else {
                    return false
                }
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelHelp () {
            this.showHelp = false;
            this.helpText = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showHelpMethod (row) {
            this.helpText = row.info;
            this.showHelp = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setPaymentEval (id) {
            switch (id) {
            case 1:
                return this.form.er.net_profit;
                break;
            case 2: 
                if (this.form.if.incomes.business_income != this.form.if.incomes.total) { return (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { return this.form.if.expenses.total }
                break;
            case 3: 
                var operation = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { operation = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { operation = this.form.if.expenses.total }; return this.form.er.net_profit - operation;
                break; 
            case 4:
                var operation = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { operation = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { operation = this.form.if.expenses.total }; return (this.form.er.net_profit - operation)*0.6;
                break;
            case 5:
                return this.form.if.surplus * 0.75;
                break;
            case 6:
                return this.form.if.incomes.total;
                break;
            case 7:
                return this.form.if.expenses.total;
                break;
            case 8:
                return this.form.if.surplus;
                break;
            default:
                
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setEval (str) {
            const ast = expr.parse(str);
            return expr.eval(ast, this.$data)
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setSuffix (row) {
            if (isNaN(row.value) || row.value == 'Infinity') {
                return 'Revisa los valores'
            }
            else {
                if (row.unit == '$') {
                    return this.setFormat(row.value);
                }
                else {
                    return [row.value,' ',row.unit].join('');
                }
            }
            
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        tableRowClassName({row, rowIndex}) {
            if (row.formula != null && this.modifiedFinancialIndicators) {
                if(row.name == 'Cobertura de la cuota' && this.pyme){
                    // Encontramos el índice del objeto con el nombre específico
                    const index = this.form.if.personalExpenses.findIndex(
                        expense => expense.personalExpenseName === "Cuotas créditos recibidos por la UF"
                    );
                    let formula = `(this.form.if.personalExpenses[${index}].personalExpenseValue/this.form.if.incomes.total) * 100`;
                    row.formula = formula;
                }
                if(row.name == 'Capacidad de pago acumulada' && this.agro){
                    
                    let formula = 'this.financialIndicatorAgro2';
                    row.formula = formula;
                }
                if(row.name == 'Índice de endeudamiento' && this.agro){
                    
                    let formula = 'this.financialIndicatorAgro1';
                    row.formula = formula;
                }
                let result = this.setEval(row.formula);
                this.form.i.financialIndicators[rowIndex].value = Number((result).toFixed(2));
                let finalFormula = [result,' ',row.alert].join('')
                if(this.setEval(finalFormula) == true || isNaN(result) || result == 'Infinity') {
                    return 'warning-row';        
                }
                else {
                    return '';
                }
                return ''
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        tableRowClassName2({row, rowIndex}) {
            if (row.name == 'Capacidad de pago (60%)' || row.name == 'Capacidad de pago (75%)') {
                return 'capacity-row';
            }
            else {
                return ''
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showNotificationError (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-glasses-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showEngineRulesNotificationError (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-glasses-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showNotificationSuccess (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-check-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success'
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentObligationChange(currentRow, oldCurrentRow) {
                this.currentObligationRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentPersonalExpensesChange(currentRow, oldCurrentRow) {
                this.currentPersonalExpenseRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentEquipmentChange(currentRow, oldCurrentRow) {
                this.currentEquipmentRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentIncomesChange(currentRow, oldCurrentRow) {
                this.currentIncomesRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentFamiliarObligationChange(currentRow, oldCurrentRow) {
                this.currentFamiliarObligationRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelAddObligation () {
            this.resetObligation();
            this.addObligation = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelAddPersonalExpense () {
            this.resetPersonalExpense();
            this.addPersonalExpense = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelAddEquipment () {
            this.resetEquipment();
            this.addEquipment = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelAddIncomes () {
            this.resetIncomes();
            this.addIncomes = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addObligationToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.obligationCreditor == '' || this.obligationAmount == '' || this.obligationPaymentValue == '' || this.obligationNumberPayments == '' || this.obligationTerm == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        this.form.of.business.obligations.push({
                            obligationCreditor:  this.obligationCreditor,
                            obligationAmount: this.obligationAmount,
                            obligationPaymentValue: this.obligationPaymentValue,
                            obligationNumberPayments: this.obligationNumberPayments,
                            obligationTerm: this.obligationTerm,
                        })
                        this.resetObligation();
                        this.addObligation = false;
                        this.showNotificationSuccess('Obligación creada correctamente');
                    }
                }
            })
        },
         /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addPersonalExpenseToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.personalExpenseName == '' || this.personalExpenseValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        this.form.if.personalExpenses.push({
                            personalExpenseName:  this.personalExpenseName,
                            personalExpenseValue:  this.personalExpenseValue,
                            editable: true,
                            lock:false
                        })
                        this.resetPersonalExpense();
                        this.updatePersonalExpensesAnotherExpenses();
                        this.addPersonalExpense = false;
                        this.showNotificationSuccess('Gasto creado correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addEquipmentToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.equipmentDescription == '' || this.equipmentValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        this.form.i.equipment.equipment.push({
                            equipmentDescription:  this.equipmentDescription,
                            equipmentValue: this.equipmentValue,
                            equipmentType: this.equipmentType,
                        })
                        this.resetEquipment();
                        this.addEquipment = false;
                        this.showNotificationSuccess('Ítem agregado correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addIncomesToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.incomeValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        this.form.if.otherIncomes.push({
                            incomeValue: this.incomeValue,
                            incomeType: this.incomeType,
                        })
                        this.resetIncomes();
                        this.addIncomes = false;
                        this.showNotificationSuccess('Ingreso neto agregado correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        resetObligation () {
            this.obligationCreditor = '';
            this.obligationAmount = '';
            this.obligationPaymentValue = '';
            this.obligationNumberPayments = '';
            this.obligationTerm = '';
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        resetPersonalExpense () {
            this.personalExpenseName = '';
            this.personalExpenseValue = '';
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        resetEquipment () {
            this.equipmentDescription = '';
            this.equipmentType = '1';
            this.equipmentValue = '';
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        resetIncomes () {
            this.incomeType = '3';
            this.incomeValue = '';
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditObligation () {
            this.editObligation = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditPersonalExpense () {
            this.resetPersonalExpense();
            this.editPersonalExpense = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditEquipment () {
            this.editEquipment = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditIncomes () {
            this.editIncomes = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditFamiliarObligation () {
            this.editFamiliarObligation = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editObligationToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.obligationCreditor == '' || this.obligationAmount == '' || this.obligationPaymentValue == '' || this.obligationNumberPayments == '' || this.obligationTerm == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        var index = this.form.of.business.obligations.indexOf(this.currentObligationRow);
                        this.form.of.business.obligations[index].obligationCreditor = this.obligationCreditor;
                        this.form.of.business.obligations[index].obligationAmount = this.obligationAmount;
                        this.form.of.business.obligations[index].obligationPaymentValue = this.obligationPaymentValue;
                        this.form.of.business.obligations[index].obligationNumberPayments = this.obligationNumberPayments;
                        this.form.of.business.obligations[index].obligationTerm = this.obligationTerm;
                        this.resetObligation();
                        this.$refs.obligationsTable.setCurrentRow();
                        this.editObligation = false;
                        this.showNotificationSuccess('Obligación editada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editPersonalExpenseToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.personalExpenseName == '' || this.personalExpenseValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        var index = this.form.if.personalExpenses.indexOf(this.currentPersonalExpenseRow);
                        this.form.if.personalExpenses[index].personalExpenseName = this.personalExpenseName;
                        this.form.if.personalExpenses[index].personalExpenseValue = this.personalExpenseValue;
                        this.resetPersonalExpense();
                        this.$refs.personalExpensesTable.setCurrentRow();
                        this.updatePersonalExpensesAnotherExpenses();
                        this.editPersonalExpense = false;
                        this.showNotificationSuccess('Gasto editada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editEquipmentToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.equipmentDescription == '' || this.equipmentValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        var index = this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow);
                        this.form.i.equipment.equipment[index].equipmentDescription = this.equipmentDescription;
                        this.form.i.equipment.equipment[index].equipmentType = this.equipmentType;
                        this.form.i.equipment.equipment[index].equipmentValue = this.equipmentValue;
                        this.resetEquipment();
                        this.$refs.equipmentsTable.setCurrentRow();
                        this.editEquipment = false;
                        this.showNotificationSuccess('Obligación editada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editIncomesToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.incomeValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        var index = this.form.if.otherIncomes.indexOf(this.currentIncomesRow);
                        this.form.if.otherIncomes[index].incomeType = this.incomeType;
                        this.form.if.otherIncomes[index].incomeValue = this.incomeValue;
                        this.resetIncomes();
                        this.$refs.incomesTable.setCurrentRow();
                        this.editIncomes = false;
                        this.showNotificationSuccess('Ingreso neto editado correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editFamiliarObligationToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // if (this.familiarObligationCreditor == '' || this.familiarObligationAmount == '' || this.familiarObligationPaymentValue == '' || this.familiarObligationResidue == '' || this.familiarObligationTerm == 0) {
                    if (this.familiarObligationCreditor == '' || this.familiarObligationAmount == '' || this.familiarObligationResidue == '') {
                        var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
                        this.form.of.familiar.familiarObligations[index].obligationCreditor = this.familiarObligationCreditor;
                        this.form.of.familiar.familiarObligations[index].obligationAmount = 0;
                        this.form.of.familiar.familiarObligations[index].obligationPaymentValue = 0;
                        this.form.of.familiar.familiarObligations[index].obligationResidue = 0;
                        this.form.of.familiar.familiarObligations[index].obligationTerm = 0;
                        this.$refs.familiarObligationsTable.setCurrentRow();
                        this.editFamiliarObligation = false;
                        this.showNotificationSuccess('Obligación familiar editada correctamente');
                    }
                    else {
                        // if(this.familiarObligationResidue > this.familiarObligationAmount) {
                        //     this.showNotificationError('El saldo no puede ser mayor al monto');
                        //     return
                        // }
                        var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
                        this.form.of.familiar.familiarObligations[index].obligationCreditor = this.familiarObligationCreditor;
                        this.form.of.familiar.familiarObligations[index].obligationAmount = this.familiarObligationAmount;
                        this.form.of.familiar.familiarObligations[index].obligationPaymentValue = this.familiarObligationPaymentValue;
                        this.form.of.familiar.familiarObligations[index].obligationResidue = this.familiarObligationResidue;
                        this.form.of.familiar.familiarObligations[index].obligationTerm = this.familiarObligationTerm;
                        this.$refs.familiarObligationsTable.setCurrentRow();
                        this.editFamiliarObligation = false;
                        this.showNotificationSuccess('Obligación familiar editada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addObligationMethod () {
            this.addObligation = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addPersonalExpenseMethod () {
            this.addPersonalExpense = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addEquipmentMethod () {
            if(this.form.i.equipment.equipment.length < 5) {
                this.addEquipment = true;
            }
            else {
                this.showNotificationError('El máximo número de de inmuebles, maquinaria y equipo es 5');
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addIncomesMethod () {
            this.addIncomes = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editObligationMethod () {
            var index = this.form.of.business.obligations.indexOf(this.currentObligationRow);
            this.obligationCreditor = this.form.of.business.obligations[index].obligationCreditor;
            this.obligationAmount = this.form.of.business.obligations[index].obligationAmount;
            this.obligationPaymentValue = this.form.of.business.obligations[index].obligationPaymentValue;
            this.obligationNumberPayments = this.form.of.business.obligations[index].obligationNumberPayments;
            this.obligationTerm = this.form.of.business.obligations[index].obligationTerm;
            this.editObligation = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editPersonalExpenseMethod () {
            var index = this.form.if.personalExpenses.indexOf(this.currentPersonalExpenseRow);
            if(!this.form.if.personalExpenses[index].editable){
                this.showNotificationError('Este campo no puede ser editado');
                return
            }
            this.personalExpenseName = this.form.if.personalExpenses[index].personalExpenseName;
            this.personalExpenseValue = this.form.if.personalExpenses[index].personalExpenseValue;
            this.editPersonalExpense = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editEquipmentMethod () {
            var index = this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow);
            this.equipmentDescription = this.form.i.equipment.equipment[index].equipmentDescription;
            this.equipmentValue = this.form.i.equipment.equipment[index].equipmentValue;
            this.equipmentType = this.form.i.equipment.equipment[index].equipmentType;
            this.editEquipment = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editIncomesMethod () {
            var index = this.form.if.otherIncomes.indexOf(this.currentIncomesRow);
            this.incomeValue = this.form.if.otherIncomes[index].incomeValue;
            this.incomeType = this.form.if.otherIncomes[index].incomeType;
            this.editIncomes = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editFamiliarObligationMethod () {
            var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
            this.familiarObligationCreditor = this.form.of.familiar.familiarObligations[index].obligationCreditor;
            this.familiarObligationAmount = this.form.of.familiar.familiarObligations[index].obligationAmount;
            this.familiarObligationPaymentValue = this.form.of.familiar.familiarObligations[index].obligationPaymentValue;
            this.familiarObligationResidue = this.form.of.familiar.familiarObligations[index].obligationResidue;
            this.familiarObligationTerm = this.form.of.familiar.familiarObligations[index].obligationTerm;
            this.editFamiliarObligation = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        removeObligationMethod () {
            this.form.of.business.obligations.splice(this.form.of.business.obligations.indexOf(this.currentObligationRow),1);
            this.currentObligationRow = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        removePersonalExpenseMethod () {
            if(this.form.if.personalExpenses[this.form.if.personalExpenses.indexOf(this.currentPersonalExpenseRow)].lock){
                this.showNotificationError('Este campo no puede ser eliminado');
                return
            }
            this.form.if.personalExpenses.splice(this.form.if.personalExpenses.indexOf(this.currentPersonalExpenseRow),1);
            this.updatePersonalExpensesAnotherExpenses();
            this.currentPersonalExpenseRow = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        removeEquipmentMethod () {
            this.form.i.equipment.equipment.splice(this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow),1);
            this.currentEquipmentRow = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        removeIncomesMethod () {
            this.form.if.otherIncomes.splice(this.form.if.otherIncomes.indexOf(this.currentIncomesRow),1);
            this.currentIncomesRow = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setFormat (value) {
            return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setIncomeType (value) {
            if (value == '1') {
                return 'Bonificaciones y comisiones'
            }
            else if (value == '2') {
                return 'Microempresariales'
            }
            else if (value == '3') {
                return 'Otros'
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toER () {
            VueScrollTo.scrollTo('#toERElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toIF () {
            VueScrollTo.scrollTo('#toIFElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toB () {
            VueScrollTo.scrollTo('#toBElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toOF () {
            VueScrollTo.scrollTo('#toOFElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toOFU () {
            VueScrollTo.scrollTo('#toOFUElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toI () {
            VueScrollTo.scrollTo('#toIElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toCP () {
            VueScrollTo.scrollTo('#toCPElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toIFI () {
            VueScrollTo.scrollTo('#toIFIElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toBusinessReferences () {
            this.$router.push('/asessments/new_asessment/customer/others/business_references');
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        getError (fieldName) {
            return this.errors.first(fieldName)
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        validateForm(scope) {
            var actualStudy;
            if (this.$store.state.isCustomer) {
                actualStudy = this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy;
            }
            else if(this.$store.state.isSpouse) {
                if(!this.pyme){
                    for (let i=0;i<this.form.i.financialIndicators.length;i++) {
                        var assign_var = 0;
                        this.form.i.financialIndicators[i].value = assign_var;
                    }
                    this.$store.dispatch('setBalance', this.$data).then(()=>{
                        var payload = {
                            stage: 'Registro de balance',
                            description: 'Se ingresan todos los datos del balance del cónyuge.',
                            dateTime: moment().format()
                        };
                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                            this.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                        });
                    });
                    return
                }
                else {
                    actualStudy = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy;
                }
            }
            else if (this.$store.state.isGuarantor) {
                actualStudy = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1;
            }
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    if (scope == 'formER') {
                        var vm = this;
                        if (actualStudy == 0) {
                            if(!vm.$store.state.isSpouse){
                                let promise = new Promise(function(resolve, reject) {
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.if.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toIF').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toIF',
                                            icon: 'IF'
                                        })
                                    }
                                    vm.toIF();
                                });
                            }
                            else{
                                let promise = new Promise(function(resolve, reject) {
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.b.locked = false;
                                        vm.form.i.equipment.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toB',
                                            icon: 'B'
                                        }
                                        ,
                                        {
                                            name: 'toI',
                                            icon: 'I'
                                        }
                                        )
                                    }
                                    vm.toB();
                                });
                            }
                        }
                        else {
                            if (vm.$store.state.isCustomer) {
                                var product = vm.$store.getters.getProductTypes.find(product => product.id == vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[0].productType);
                            }
                            else if(vm.$store.state.isSpouse) {
                                var product = vm.$store.getters.getProductTypes.find(product => product.id == vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.studies[0].productType);
                            }
                            else if (vm.$store.state.isGuarantor) {
                                var product = vm.$store.getters.getProductTypes.find(product => product.id == vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[vm.$store.state.assesments[vm.$store.state.actualAssesment].actualGuarantors].studies[0].productType);
                            }
                            if (product.name.toLowerCase() == 'consumo') {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.if.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toIF').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toIF',
                                            icon: 'IF'
                                        })
                                    }
                                    vm.toIF();
                                });
                            }
                            else {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.form.if.incomes.business_income= 0;
                                    vm.form.if.incomes.titular_salary= 0;
                                    vm.form.if.incomes.spouse_salary= 0;
                                    vm.form.if.incomes.others= 0;
                                    vm.form.if.incomes.total= 0;
                                    vm.form.if.expenses.rental= 0;
                                    vm.form.if.expenses.feeding= 0;
                                    vm.form.if.expenses.public_services= 0;
                                    vm.form.if.expenses.education= 0;
                                    vm.form.if.expenses.health= 0;
                                    vm.form.if.expenses.credits= 0;
                                    vm.form.if.expenses.transport= 0;
                                    vm.form.if.expenses.others= 0;
                                    vm.form.if.expenses.incidentals= 0;
                                    vm.form.if.expenses.total= 0;
                                    vm.form.b.locked = false;
                                    vm.form.i.equipment.locked = false;
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toB',
                                            icon: 'B'
                                        }
                                        ,
                                        {
                                            name: 'toI',
                                            icon: 'I'
                                        }
                                        )
                                    }
                                    vm.toB();
                                });
                            }
                        }
                        
                    }
                    else if (scope == 'formIF') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.b.locked = false;
                                vm.form.i.equipment.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                vm.fabActions.push({
                                    name: 'toB',
                                    icon: 'B'
                                },
                                {
                                    name: 'toI',
                                    icon: 'I'
                                }
                                )
                            }
                            vm.toB();
                        });
                    }
                    else if (scope == 'formB') {
                        var vm = this;
                        // if (parseFloat(vm.$store.state.assesments[vm.$store.state.actualAssesment].amount) > parseFloat(vm.form.b.passives.patrimony)) {
                        //     vm.showEngineRulesNotificationError('El monto solicitado es mayor al tamaño del negocio.');
                        // }
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                if (actualStudy == 0) {
                                    vm.form.of.locked = false;
                                    vm.form.of.familiar.locked = false;
                                }
                                else {
                                    vm.form.of.locked = false;
                                }
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toOF').length > 0) {
                                if (actualStudy == 0) {
                                    vm.fabActions.push({
                                        name: 'toOF',
                                        icon: 'OF'
                                    },
                                    {
                                        name: 'toOFU',
                                        icon: 'OFU'
                                    })
                                }
                                else {
                                    vm.fabActions.push({
                                        name: 'toOF',
                                        icon: 'OF'
                                    })
                                }
                            }
                            vm.toOF();
                        });
                    }
                    else if (scope == 'formOF') {
                        var vm = this;
                        if (actualStudy == 0) {
                            let promise = new Promise(function(resolve, reject) {
                                vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                    vm.form.of.familiar.locked = false;
                                    resolve();
                                });
                            }).then(function(resolve){
                                if(!vm.fabActions.filter(element=> element.name == 'toOFU').length > 0) {
                                    vm.fabActions.push({
                                        name: 'toOFU',
                                        icon: 'OFU'
                                    })
                                }
                                vm.toOFU();
                            });
                        }
                        else {
                            let promise = new Promise(function(resolve, reject) {
                                vm.form.of.familiar.familiarObligations[0].obligationAmount = 0;
                                vm.form.of.familiar.familiarObligations[0].obligationResidue = 0;
                                vm.form.of.familiar.familiarObligations[0].obligationPaymentValue = 0;
                                vm.form.of.familiar.familiarObligations[1].obligationAmount = 0;
                                vm.form.of.familiar.familiarObligations[1].obligationResidue = 0;
                                vm.form.of.familiar.familiarObligations[1].obligationPaymentValue = 0;
                                vm.form.of.familiar.familiarObligations[2].obligationAmount = 0;
                                vm.form.of.familiar.familiarObligations[2].obligationResidue = 0;
                                vm.form.of.familiar.familiarObligations[2].obligationPaymentValue = 0;
                                vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                    vm.form.i.equipment.locked = false;
                                    resolve();
                                });
                            }).then(function(resolve){
                                if(!vm.fabActions.filter(element=> element.name == 'toI').length > 0) {
                                    vm.fabActions.push({
                                        name: 'toI',
                                        icon: 'I'
                                    })
                                }
                                vm.toI();
                            });
                        }
                    }
                    else if (scope == 'formOFU') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.i.equipment.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toI').length > 0) {
                                vm.fabActions.push({
                                    name: 'toI',
                                    icon: 'I'
                                })
                            }
                            vm.toI();
                        });
                    }
                    else if (scope == 'formI') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.cp.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toCP').length > 0) {
                                vm.fabActions.push({
                                    name: 'toCP',
                                    icon: 'CP'
                                })
                            }
                            vm.toCP();
                        });
                    }
                    else if (scope == 'formCP') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.i.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toIFI').length > 0) {
                                vm.fabActions.push({
                                    name: 'toIFI',
                                    icon: 'IFI'
                                })
                            }
                            vm.toIFI();
                        });
                    }
                    else if (scope == 'formIFI') {
                        var vm = this;
                        if(vm.agro){
                            if (!vm.form.i.agroDataSourcePaymentData || vm.form.i.agroDataSourcePaymentData.trim() === '') {
                                vm.showNotificationError('La fuente alternativa de pagos y gastos estacionales es obligatoria');
                                return;
                            }
                        }
                        if (actualStudy == 0 && !vm.$store.state.isSpouse) {
                            if (vm.form.er.locked || vm.form.if.locked || vm.form.b.locked || vm.form.of.locked || vm.form.of.familiar.locked || vm.form.i.equipment.locked || vm.form.cp.locked || vm.form.i.locked) {
                                vm.showNotificationError('Todas las secciones no han sido desbloqueadas, revisa y continúa');
                                return
                            }
                        }
                        else {
                            if (vm.form.er.locked || vm.form.b.locked || vm.form.of.locked || vm.form.i.equipment.locked || vm.form.cp.locked || vm.form.i.locked) {
                                vm.showNotificationError('Todas las secciones no han sido desbloqueadas, revisa y continúa');
                                return
                            }
                        }
                        if (!this.$store.state.syncReturn) {
                            // var vm = this;
                            var sum = 0;
                            for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                    sum = sum + 1;
                                }
                            }
                            if (sum > 0) {
                                swal({
                                    title: '¿Está seguro?',
                                    text: 'Algunos indicadores necesitan atención, si continúas esos valores quedarán en 0',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, continuar',
                                    cancelButtonText: 'No, cancelar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.modifiedFinancialIndicators = false;
                                    for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                        if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                            var assign_var = 0;
                                            vm.form.i.financialIndicators[i].value = assign_var;
                                        }
                                    }
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        var payload = {
                                            stage: 'Registro de balance',
                                            description: 'Se ingresan todos los datos del balance con alerta de atención de indicadores.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (actualStudy == 0) {
                                                vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                                            }
                                            else {
                                                vm.$router.push('/asessments/new_asessment/customer/others/financial_indicators');
                                            } 
                                        });
                                    });
                                    
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                })
                            }
                            else {
                                vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                    var payload = {
                                        stage: 'Registro de balance',
                                        description: 'Se ingresan todos los datos del balance.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                        if (actualStudy == 0) {
                                            vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                                        }
                                        else {
                                            vm.$router.push('/asessments/new_asessment/customer/others/financial_indicators');
                                        }
                                    });
                                });
                            }
                        }
                        else if (vm.$store.state.syncReturn) {
                            var sum = 0;
                            for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                    sum = sum + 1;
                                }
                            }
                            if (sum > 0) {
                                swal({
                                    title: '¿Está seguro?',
                                    text: 'Algunos indicadores necesitan atención, si continúas esos valores quedarán en 0',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, continuar',
                                    cancelButtonText: 'No, cancelar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.modifiedFinancialIndicators = false;
                                    for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                        if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                            var assign_var = 0;
                                            vm.form.i.financialIndicators[i].value = assign_var;
                                        }
                                    }
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        var payload = {
                                            stage: 'Registro de balance',
                                            description: 'Se ingresan todos los datos del balance con alerta de atención de indicadores.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if(vm.agro){
                                                vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                                            }
                                            else {
                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                    vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                });
                                            }
                                        });
                                    });
                                    
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                })
                            }
                            else {
                                vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                    var payload = {
                                        stage: 'Registro de balance',
                                        description: 'Se ingresan todos los datos del balance.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                        if(vm.agro){
                                            vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                                        }
                                        else {
                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                            });
                                        }
                                    });
                                });
                            }
                        }
                        
                    } 
                }
                else {
                    this.$el.querySelector('[data-vv-id="'+this.$validator.errors.items[0].field+'"]').focus();
                    const fieldName = this.$validator.errors.items[0].field.replace(/^.*\./, '');
                    this.showNotificationError(`El campo ${fieldName} es obligatorio`);
                }
            });
        }
    },
    mounted () {
        if (this.$store.state.isCustomer) {
            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType);
            this.productValidator(product);
            if (this.microcredit) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts[0].totalTaxes);
                                    this.form.er.operative_expenses.taxes.locked = true;
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalInventory);
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value != 0) {
                            this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value;
                        }
                        else {
                            this.form.er.credit_sales = 0;
                        }
                    }
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            if (FinancialIndicators[i].restriction == null && !this.pyme) {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                            else if(this.pyme){
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                        }
                    }
                    if (this.form.cp.paymentCapacity.length == 0) {
                        if(this.pyme){
                            for (let i=0; i<PaymentCapacityPyme.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacityPyme[i].id ,
                                    name: PaymentCapacityPyme[i].name ,
                                    formula: PaymentCapacityPyme[i].formula,
                                    info: PaymentCapacityPyme[i].info,
                                    value: 0
                                })
                            }
                        }
                        if(!this.pyme){
                            for (let i=0; i<PaymentCapacity.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacity[i].id ,
                                    name: PaymentCapacity[i].name ,
                                    formula: PaymentCapacity[i].formula,
                                    info: PaymentCapacity[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts[0].totalTaxes);
                                    this.form.er.operative_expenses.taxes.locked = true;
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalInventory);
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value != 0) {
                        this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value;
                    }
                    else {
                        this.form.er.credit_sales = 0;
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy > 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        // this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].extraPayment;
                        // this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].netSalary;
                    }
                }

                if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse !== 'undefined' && !_.isEmpty(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse) && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].if.incomes.total;
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        // this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit * 0.7;
                        this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit;
                    }
                }
                else {
                    console.info('no')
                    this.form.if.incomes.spouse_salary = 0;
                }
                
            }
            else if(this.pyme) {
                if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102.length > 0){
                    this.fm102quota = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102[0].analyst_proposal.payment_value;   
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    // // this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts[0].totalTaxes);
                                    // this.form.er.operative_expenses.taxes.value = 0;
                                    // this.form.er.operative_expenses.taxes.locked = true;
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Otros gastos') {
                                this.form.er.operative_expenses.others.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.others.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalInventory);
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value != 0) {
                            this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value;
                        }
                        else {
                            this.form.er.credit_sales = 0;
                        }
                    }
                    if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].obligations.length > 0) {
                        let totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].totalTitular;
                        let totalObligationsCAV = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].totalObligationsCAV;
                        let financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].obligations;
                        // Tipos de obligación que queremos filtrar
                        const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                        const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                        const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                        const totals = this.sumObligations(financialObligations);
                        
                        // Mostrar el resultado
                        this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                        this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                        this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                        this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                        this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                        this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
                        const sumSummarizedQuotas = summarizedQuotas["NEGOCIO"] + summarizedQuotas["BMM NEGOCIO"] + summarizedQuotas["PROVEEDOR"] + summarizedQuotas["OTRAS OBLIGA"];
                        this.form.er.operative_expenses.financial_expenses.value = sumSummarizedQuotas;
                        
                        this.form.if.personalExpenses.forEach(expense => {
                            if (expense.personalExpenseName === 'Cuotas créditos recibidos por la UF') {
                                expense.personalExpenseValue = summarizedQuotas["UNID FLIAR"];
                            }
                        });

                        this.updateObligationResidue(totalObligationsCAV);
                        this.form.indebtness = totalObligations;
                        // 1. Filtra y suma por separado cada campo para las obligaciones de tipo "UNID FLIAR" y "TDC"
                        const unitFamilyTDCObligationsSum = financialObligations
                            .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "TDC")
                            .reduce((sum, obligation) => {
                                sum.residue += (obligation.obligationResidue || 0);
                                sum.amount += (obligation.obligationAmountCredit || 0);
                                sum.quota += (obligation.obligationQuota || 0);
                                sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                return sum;
                            }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                        // 2. Filtra y suma por separado cada campo para las obligaciones de tipo "TDC" o "CAV"
                        const tdcOrCavObligationsSum = financialObligations
                            .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType != "TDC" && obligation.obligationAccountType != "CAV")
                            .reduce((sum, obligation) => {
                                sum.residue += (obligation.obligationResidue || 0);
                                sum.amount += (obligation.obligationAmountCredit || 0);
                                sum.quota += (obligation.obligationQuota || 0);
                                sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                return sum;
                            }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                        // 3. Filtra y suma por separado cada campo solo para las obligaciones de tipo "CAV"
                        const cavOnlyObligationsSum = financialObligations
                            .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "CAV")
                            .reduce((sum, obligation) => {
                                sum.residue += (obligation.obligationResidue || 0);
                                sum.amount += (obligation.obligationAmountCredit || 0);
                                sum.quota += (obligation.obligationQuota || 0);
                                sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                return sum;
                            }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });


                        this.form.of.familiar.familiarObligations.forEach(obligation => {
                            if (obligation.obligationCreditor === 'Tarjeta de crédito') {
                                obligation.obligationResidue = unitFamilyTDCObligationsSum.residue;
                                obligation.obligationAmount = unitFamilyTDCObligationsSum.amount;
                                obligation.obligationPaymentValue = unitFamilyTDCObligationsSum.quota;
                                obligation.obligationTerm = unitFamilyTDCObligationsSum.pendingQuota;
                            } else if (obligation.obligationCreditor === 'Crédito consumo') {
                                obligation.obligationResidue = tdcOrCavObligationsSum.residue;
                                obligation.obligationAmount = tdcOrCavObligationsSum.amount;
                                obligation.obligationPaymentValue = tdcOrCavObligationsSum.quota;
                                obligation.obligationTerm = tdcOrCavObligationsSum.pendingQuota;
                            } else if (obligation.obligationCreditor === 'Crédito vivienda') {
                                obligation.obligationResidue = cavOnlyObligationsSum.residue;
                                obligation.obligationAmount = cavOnlyObligationsSum.amount;
                                obligation.obligationPaymentValue = cavOnlyObligationsSum.quota;
                                obligation.obligationTerm = cavOnlyObligationsSum.pendingQuota;
                            }
                        });
                        this.form.of.business.obligations = [];
                        financialObligations.forEach(financialObligation => {
                            if(financialObligation.obligationType != 'UNID FLIAR'){
                                this.form.of.business.obligations.push({
                                obligationCreditor:  financialObligation.obligationEntity,
                                obligationAmount: financialObligation.obligationAmountCredit,
                                obligationPaymentValue: financialObligation.obligationQuota,
                                obligationNumberPayments: financialObligation.obligationPendingQuota,
                                obligationTerm: financialObligation.obligationTerm,
                            })
                            }
                        });

                    }
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            if (FinancialIndicators[i].restriction == null && !this.pyme) {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                            else if(this.pyme){
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                        }
                    }
                    if (this.form.cp.paymentCapacity.length == 0) {
                        if(this.pyme){
                            for (let i=0; i<PaymentCapacityPyme.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacityPyme[i].id ,
                                    name: PaymentCapacityPyme[i].name ,
                                    formula: PaymentCapacityPyme[i].formula,
                                    info: PaymentCapacityPyme[i].info,
                                    value: 0
                                })
                            }
                        }
                        if(!this.pyme){
                            for (let i=0; i<PaymentCapacity.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacity[i].id ,
                                    name: PaymentCapacity[i].name ,
                                    formula: PaymentCapacity[i].formula,
                                    info: PaymentCapacity[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                if (subcategory == 'transporte') {
                                    // this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].transportCosts[0].totalTaxes);
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                                else {
                                    this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.transport.locked = true;
                                    }
                                    this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses);
                                    if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses) != 0) {
                                        this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalOthersOperatingExpenses;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Otros gastos') {
                                this.form.er.operative_expenses.others.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.others.locked = true;
                                }
                            }
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalInventory);
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value != 0) {
                        this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].creditSales.value;
                    }
                    else {
                        this.form.er.credit_sales = 0;
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy > 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        // this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].extraPayment;
                        // this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].netSalary;
                    }
                }

                if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse !== 'undefined' && !_.isEmpty(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse) && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].if.incomes.total;
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        // this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit * 0.7;
                        this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit;
                    }
                }
                else {
                    // this.form.if.incomes.spouse_salary = 0;
                }
                if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].obligations.length > 0) {
                    let totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].totalTitular;
                    let totalObligationsCAV = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].totalObligationsCAV;
                    let financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].financialObligations[0].obligations;
                    // Tipos de obligación que queremos filtrar
                    const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                    const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                    const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                    const totals = this.sumObligations(financialObligations);
                    
                    this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                    
                    this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
                    const sumSummarizedQuotas = summarizedQuotas["NEGOCIO"] + summarizedQuotas["BMM NEGOCIO"] + summarizedQuotas["PROVEEDOR"] + summarizedQuotas["OTRAS OBLIGA"];
                    
                        
                     this.form.if.personalExpenses.forEach(expense => {
                        if (expense.personalExpenseName === 'Cuotas créditos recibidos por la UF') {
                            expense.personalExpenseValue = summarizedQuotas["UNID FLIAR"];
                        }
                    });

                    this.updateObligationResidue(totalObligationsCAV);
                    this.form.indebtness = totalObligations;
                    // 1. Filtra y suma por separado cada campo para las obligaciones de tipo "UNID FLIAR" y "TDC"
                    const unitFamilyTDCObligationsSum = financialObligations
                        .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "TDC")
                        .reduce((sum, obligation) => {
                            sum.residue += (obligation.obligationResidue || 0);
                            sum.amount += (obligation.obligationAmountCredit || 0);
                            sum.quota += (obligation.obligationQuota || 0);
                            sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                            return sum;
                        }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                    // 2. Filtra y suma por separado cada campo para las obligaciones de tipo "TDC" o "CAV"
                    const tdcOrCavObligationsSum = financialObligations
                        .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType != "TDC" && obligation.obligationAccountType != "CAV")
                        .reduce((sum, obligation) => {
                            sum.residue += (obligation.obligationResidue || 0);
                            sum.amount += (obligation.obligationAmountCredit || 0);
                            sum.quota += (obligation.obligationQuota || 0);
                            sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                            return sum;
                        }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                    // 3. Filtra y suma por separado cada campo solo para las obligaciones de tipo "CAV"
                    const cavOnlyObligationsSum = financialObligations
                        .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "CAV")
                        .reduce((sum, obligation) => {
                            sum.residue += (obligation.obligationResidue || 0);
                            sum.amount += (obligation.obligationAmountCredit || 0);
                            sum.quota += (obligation.obligationQuota || 0);
                            sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                            return sum;
                        }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });


                    this.form.of.familiar.familiarObligations.forEach(obligation => {
                        if (obligation.obligationCreditor === 'Tarjeta de crédito') {
                            obligation.obligationResidue = unitFamilyTDCObligationsSum.residue;
                            obligation.obligationAmount = unitFamilyTDCObligationsSum.amount;
                            obligation.obligationPaymentValue = unitFamilyTDCObligationsSum.quota;
                            obligation.obligationTerm = unitFamilyTDCObligationsSum.pendingQuota;
                        } else if (obligation.obligationCreditor === 'Crédito consumo') {
                            obligation.obligationResidue = tdcOrCavObligationsSum.residue;
                            obligation.obligationAmount = tdcOrCavObligationsSum.amount;
                            obligation.obligationPaymentValue = tdcOrCavObligationsSum.quota;
                            obligation.obligationTerm = tdcOrCavObligationsSum.pendingQuota;
                        } else if (obligation.obligationCreditor === 'Crédito vivienda') {
                            obligation.obligationResidue = cavOnlyObligationsSum.residue;
                            obligation.obligationAmount = cavOnlyObligationsSum.amount;
                            obligation.obligationPaymentValue = cavOnlyObligationsSum.quota;
                            obligation.obligationTerm = cavOnlyObligationsSum.pendingQuota;
                        }
                    });
                    this.form.of.business.obligations = [];
                    financialObligations.forEach(financialObligation => {
                        if(financialObligation.obligationType != 'UNID FLIAR'){
                            this.form.of.business.obligations.push({
                            obligationCreditor:  financialObligation.obligationEntity,
                            obligationAmount: financialObligation.obligationAmountCredit,
                            obligationPaymentValue: financialObligation.obligationQuota,
                            obligationNumberPayments: financialObligation.obligationPendingQuota,
                            obligationTerm: financialObligation.obligationTerm,
                        })
                        }
                    });

                }
            }
            else if(this.agro){
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    let anotherExpenses = null;
                    let cashFlow = null;
                    let cashFlowData = null;
                    let estate = null;
                    let expenses = null;
                    let financialObligations = null;
                    let historicalYields = null;
                    let inventory = null;
                    let labour = null;
                    let machinery = null;
                    let product = null;
                    let salary = null;
                    let seasonalSales = null;
                    let totalObligations = 0;
                    if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations){
                        totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations[0].totalTitular;
                        financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations[0].obligations;
                    }
                    else {
                        totalObligations = 0;
                        financialObligations = [];
                    }
                    this.form.indebtness = totalObligations;
                    let agroData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData;
                    anotherExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.anotherExpenses;
                    cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow;
                    cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
                    estate = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.estate;
                    expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.expenses;
                    historicalYields = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.historicalYields;
                    inventory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.inventory;
                    labour = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.labour;
                    machinery = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.machinery;
                    product = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.product;
                    salary = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.salary;
                    seasonalSales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.seasonalSales;
                    
                    // Tipos de obligación que queremos filtrar
                    const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                    const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                    const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                    const totals = this.sumObligations(financialObligations);
                    
                    this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                    
                    this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
    
                    const clientTerm = parseInt(cashFlow.clientTerm, 10);
                    const state = this.$store.state;
                    const assesments = state.assesments || {};
                    const actualAssesment = assesments[state.actualAssesment] || {};
                    const customer = actualAssesment.customer || {};
                    const studies = customer.studies || {};
                    const actualStudy = studies[customer.actualStudy] || {};
                    const agroData_ = actualStudy.agroData || {};
                    const cashFlowData_ = agroData_.cashFlowData || {};
                    const microBalance = agroData_.microBalance || {};
                    const spouseBalance = agroData_.spouseBalance || {};

                    // Asegurar que totalizedYields sea tratado correctamente
                    const totalizedYields = cashFlowData_.totalizedYields && typeof cashFlowData_.totalizedYields === 'object'
                        ? Object.keys(cashFlowData_.totalizedYields).map(key => cashFlowData_.totalizedYields[key] || 0)
                        : [0, 0, 0, 0, 0];

                    // Asegurar que totalizedSeasonalSales sea tratado correctamente
                    const totalizedSeasonalSales = cashFlowData_.totalizedSeasonalSales && typeof cashFlowData_.totalizedSeasonalSales === 'object'
                        ? Object.keys(cashFlowData_.totalizedSeasonalSales).map(key => 
                            (cashFlowData_.totalizedSeasonalSales[key] && cashFlowData_.totalizedSeasonalSales[key].total) || 0)
                        : [0, 0, 0, 0, 0];

                    // Sumar todos los valores sin errores
                    const totalSumIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0) + 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData_.sumConsolidatedJournals || 0) + 
                        (agroData_.sumConsolidatedSalaries || 0);
                    
                    const totalIncomesRounded = Math.round(totalSumIncomes * 100) / 100;
    
                    // Aplicar la lógica según el valor de clientTerm
                    const divisor = clientTerm > 24 ? 25 : clientTerm + 1;
                    const adjustedIncome = totalIncomesRounded / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedIncomeRounded = Math.round(adjustedIncome * 100) / 100;
    
                    console.log("Adjusted Income:", adjustedIncomeRounded);
                    // this.form.er.account_sales = adjustedIncomeRounded;
                    this.$set(this.form.er, 'account_sales', adjustedIncomeRounded);
    
                    const totalizedExpenses = cashFlowData_.totalizedExpenses || {};

                    // Verificar si son arrays antes de acceder a los valores
                    const historicalExpenses = Array.isArray(totalizedExpenses.historical)
                        ? totalizedExpenses.historical.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    const seasonalExpenses = Array.isArray(totalizedExpenses.seasonal)
                        ? totalizedExpenses.seasonal.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    // Acceder a valores únicos de forma segura
                    const totalizedLabour = cashFlowData_.totalizedLabour || 0;
                    const totalizedAnotherExpenses = cashFlowData_.totalizedAnotherExpenses || 0;
                    const totalizedFinancialObligationsByMonth = cashFlowData_.totalizedFinancialObligationsByMonth || 0;

                    // Sumar todos los valores sin errores
                    const totalExpensesSum =
                        (historicalExpenses[0] || 0) +
                        (historicalExpenses[1] || 0) +
                        (historicalExpenses[2] || 0) +
                        (historicalExpenses[3] || 0) +
                        (historicalExpenses[4] || 0) +
                        (seasonalExpenses[0] || 0) +
                        (seasonalExpenses[1] || 0) +
                        (seasonalExpenses[2] || 0) +
                        (seasonalExpenses[3] || 0) +
                        (seasonalExpenses[4] || 0) +
                        totalizedLabour +
                        totalizedAnotherExpenses + 
                        totalizedFinancialObligationsByMonth;

                    // Mostrar valores en la consola
                    console.log("Gastos históricos:", historicalExpenses);
                    console.log("Gastos estacionales:", seasonalExpenses);
                    console.log("Totalized Labour:", totalizedLabour);
                    console.log("Totalized Another Expenses:", totalizedAnotherExpenses);
                    console.log("Suma total de todos los gastos:", totalExpensesSum);
    
                    // Aplicar la fórmula de ajuste, si clientTerm > 24, dividir entre 25, si no entre clientTerm + 1
                    const adjustedTotal = totalExpensesSum / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedTotalRounded = Math.round(adjustedTotal * 100) / 100;
    
                    console.log("Adjusted Total:", adjustedTotalRounded);
                    // this.form.er.sales_costs = adjustedTotalRounded;
                    this.form.er.credit_sales = 0;
                    this.$set(this.form.er, 'sales_costs', adjustedTotalRounded);
    
                    // Calcular la suma de todos los inventarios, manejando datos inválidos
                    const totalInventory = Array.isArray(inventory)
                    ? inventory.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryTotal === 'number' ? item.inventoryTotal : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalInventoryRounded = Math.round(totalInventory * 100) / 100;
    
                    console.log("Total Inventory:", totalInventoryRounded);
                    this.form.b.assets.inventory = totalInventoryRounded;
    
                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalEstateValue = Array.isArray(estate)
                    ? estate.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.estateValue === 'number' ? item.estateValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalEstateValueRounded = Math.round(totalEstateValue * 100) / 100;
    
                    console.log("Total Estate Value:", totalEstateValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_estate_computed = totalEstateValueRounded;

                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalMachineryValue = Array.isArray(machinery)
                    ? machinery.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryValue === 'number' ? item.inventoryValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalMachineryValueRounded = Math.round(totalMachineryValue * 100) / 100;
    
                    console.log("Total Machinery Value:", totalMachineryValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_equipment_computed = totalMachineryValueRounded;

                    // Función para manejar valores no válidos
                    function safeValue(value) {
                        return isNaN(value) || value === undefined || value === null ? 0 : value;
                    }
                    // Sumar todos los valores sin errores
                    const totalIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0);
                    
                    // Sumar todos los valores sin errores
                    const totalAnotherIncomes = 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData_.sumConsolidatedJournals || 0) + 
                        (agroData_.sumConsolidatedSalaries || 0);


                    let agroIncomesParticipation = Math.round(
                        ((totalIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;

                    let agroExpensesParticipation = Math.round(
                        ((totalExpensesSum) 
                        / (totalIncomes)) * 100 * 100
                    ) / 100;

                    let agroAnotherIncomesParticipation = Math.round(
                        ((totalAnotherIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;
                    
                    // Asegurar que totalizedFamiliarExpenses existe y no es null o undefined
                    const totalizedFamiliarExpenses = (cashFlowData_ && cashFlowData_.totalizedFamiliarExpenses !== undefined && cashFlowData_.totalizedFamiliarExpenses !== null) 
                        ? cashFlowData_.totalizedFamiliarExpenses 
                        : 0;

                    // Asegurar que loanPayment sea un número válido
                    const loanPayment = (agroData_ && agroData_.creditParameters && agroData_.creditParameters.loanPayment !== undefined && agroData_.creditParameters.loanPayment !== null) 
                        ? parseFloat(agroData_.creditParameters.loanPayment) 
                        : 0;

                    // Acceder a assessmentAmount sin `?.`
                    const assessmentAmount = (this.$store.state.assesments 
                        && this.$store.state.assesments[this.$store.state.actualAssesment] 
                        && this.$store.state.assesments[this.$store.state.actualAssesment].amount !== undefined)
                        ? this.$store.state.assesments[this.$store.state.actualAssesment].amount
                        : 0;
                    
                    // Asegurar que los valores existen y no son undefined o null
                    const totalPassivePatrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.total_passive_patrimony !== undefined)
                        ? this.form.b.passives.total_passive_patrimony
                        : 0;

                    const patrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.patrimony !== undefined && this.form.b.passives.patrimony !== 0)
                        ? this.form.b.passives.patrimony
                        : 1; // Evita división por 0

                    // Calcular financialIndicatorAgro1 de forma segura
                    let financialIndicatorAgro1 = (totalPassivePatrimony + assessmentAmount) / patrimony;

                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro1 = Math.round(financialIndicatorAgro1 * 100) / 100;

                    // Calcular financialIndicatorAgro de forma segura
                    let financialIndicatorAgro = 
                        (totalIncomesRounded - (totalExpensesSum + totalizedFamiliarExpenses) + assessmentAmount) / 
                        (loanPayment * clientTerm || 1); // Evita división por 0 si loanPayment es 0
                    
                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro2 = Math.round(financialIndicatorAgro * 100) / 100;

                    var dataConsolidated = {
                        incomes: {
                            totalIncomesRounded: totalIncomesRounded
                        },
                        expenses: {
                            totalSum: totalExpensesSum
                        },
                        others: {
                            
                        },
                        participations: {
                            agroIncomesParticipation: agroIncomesParticipation,
                            agroExpensesParticipation: agroExpensesParticipation,
                            agroAnotherIncomesParticipation: agroAnotherIncomesParticipation
                        }
                    }
                    this.setCashFlowBalance(dataConsolidated);
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicatorsAgro.length;i++) {
                            if (FinancialIndicatorsAgro[i].restriction == 'AG') {
                                this.form.i.financialIndicators.push({
                                    id: FinancialIndicatorsAgro[i].id ,
                                    name: FinancialIndicatorsAgro[i].name ,
                                    alert: FinancialIndicatorsAgro[i].alert ,
                                    unit: FinancialIndicatorsAgro[i]. unit,
                                    formula: FinancialIndicatorsAgro[i].formula,
                                    info: FinancialIndicatorsAgro[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    let anotherExpenses = null;
                    let cashFlow = null;
                    let cashFlowData = null;
                    let estate = null;
                    let expenses = null;
                    let financialObligations = null;
                    let historicalYields = null;
                    let inventory = null;
                    let labour = null;
                    let machinery = null;
                    let product = null;
                    let salary = null;
                    let seasonalSales = null;
                    let totalObligations = 0;
                    if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations){
                        totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations[0].totalTitular;
                        financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations[0].obligations;
                    }
                    else {
                        totalObligations = 0;
                        financialObligations = [];
                    }
                    this.form.indebtness = totalObligations;
                    let agroData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData;
                    anotherExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.anotherExpenses;
                    cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow;
                    cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
                    estate = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.estate;
                    expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.expenses;
                    historicalYields = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.historicalYields;
                    inventory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.inventory;
                    labour = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.labour;
                    machinery = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.machinery;
                    product = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.product;
                    salary = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.salary;
                    seasonalSales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.seasonalSales;
                    
                    // Tipos de obligación que queremos filtrar
                    const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                    const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                    const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                    const totals = this.sumObligations(financialObligations);
                    
                    this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                    
                    this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
    
                    const clientTerm = parseInt(cashFlow.clientTerm, 10);
                    const state = this.$store.state;
                    const assesments = state.assesments || {};
                    const actualAssesment = assesments[state.actualAssesment] || {};
                    const customer = actualAssesment.customer || {};
                    const studies = customer.studies || {};
                    const actualStudy = studies[customer.actualStudy] || {};
                    const agroData_ = actualStudy.agroData || {};
                    const cashFlowData_ = agroData_.cashFlowData || {};
                    const microBalance = agroData_.microBalance || {};
                    const spouseBalance = agroData_.spouseBalance || {};

                    // Asegurar que totalizedYields sea tratado correctamente
                    const totalizedYields = cashFlowData_.totalizedYields && typeof cashFlowData_.totalizedYields === 'object'
                        ? Object.keys(cashFlowData_.totalizedYields).map(key => cashFlowData_.totalizedYields[key] || 0)
                        : [0, 0, 0, 0, 0];

                    // Asegurar que totalizedSeasonalSales sea tratado correctamente
                    const totalizedSeasonalSales = cashFlowData_.totalizedSeasonalSales && typeof cashFlowData_.totalizedSeasonalSales === 'object'
                        ? Object.keys(cashFlowData_.totalizedSeasonalSales).map(key => 
                            (cashFlowData_.totalizedSeasonalSales[key] && cashFlowData_.totalizedSeasonalSales[key].total) || 0)
                        : [0, 0, 0, 0, 0];

                    // Sumar todos los valores sin errores
                    const totalSumIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0) + 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData_.sumConsolidatedJournals || 0) + 
                        (agroData_.sumConsolidatedSalaries || 0);
                    
                    const totalIncomesRounded = Math.round(totalSumIncomes * 100) / 100;
    
                    // Aplicar la lógica según el valor de clientTerm
                    const divisor = clientTerm > 24 ? 25 : clientTerm + 1;
                    const adjustedIncome = totalIncomesRounded / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedIncomeRounded = Math.round(adjustedIncome * 100) / 100;
    
                    console.log("Adjusted Income:", adjustedIncomeRounded);
                    // this.form.er.account_sales = adjustedIncomeRounded;
                    this.$set(this.form.er, 'account_sales', adjustedIncomeRounded);
    
                    const totalizedExpenses = cashFlowData_.totalizedExpenses || {};

                    // Verificar si son arrays antes de acceder a los valores
                    const historicalExpenses = Array.isArray(totalizedExpenses.historical)
                        ? totalizedExpenses.historical.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    const seasonalExpenses = Array.isArray(totalizedExpenses.seasonal)
                        ? totalizedExpenses.seasonal.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    // Acceder a valores únicos de forma segura
                    const totalizedLabour = cashFlowData_.totalizedLabour || 0;
                    const totalizedAnotherExpenses = cashFlowData_.totalizedAnotherExpenses || 0;
                    const totalizedFinancialObligationsByMonth = cashFlowData_.totalizedFinancialObligationsByMonth || 0;

                    // Sumar todos los valores sin errores
                    const totalExpensesSum =
                        (historicalExpenses[0] || 0) +
                        (historicalExpenses[1] || 0) +
                        (historicalExpenses[2] || 0) +
                        (historicalExpenses[3] || 0) +
                        (historicalExpenses[4] || 0) +
                        (seasonalExpenses[0] || 0) +
                        (seasonalExpenses[1] || 0) +
                        (seasonalExpenses[2] || 0) +
                        (seasonalExpenses[3] || 0) +
                        (seasonalExpenses[4] || 0) +
                        totalizedLabour +
                        totalizedAnotherExpenses + 
                        totalizedFinancialObligationsByMonth;

                    // Mostrar valores en la consola
                    console.log("Gastos históricos:", historicalExpenses);
                    console.log("Gastos estacionales:", seasonalExpenses);
                    console.log("Totalized Labour:", totalizedLabour);
                    console.log("Totalized Another Expenses:", totalizedAnotherExpenses);
                    console.log("Suma total de todos los gastos:", totalExpensesSum);
    
                    // Aplicar la fórmula de ajuste, si clientTerm > 24, dividir entre 25, si no entre clientTerm + 1
                    const adjustedTotal = totalExpensesSum / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedTotalRounded = Math.round(adjustedTotal * 100) / 100;
    
                    console.log("Adjusted Total:", adjustedTotalRounded);
                    // this.form.er.sales_costs = adjustedTotalRounded;
                    this.form.er.credit_sales = 0;
                    this.$set(this.form.er, 'sales_costs', adjustedTotalRounded);
    
                    // Calcular la suma de todos los inventarios, manejando datos inválidos
                    const totalInventory = Array.isArray(inventory)
                    ? inventory.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryTotal === 'number' ? item.inventoryTotal : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalInventoryRounded = Math.round(totalInventory * 100) / 100;
    
                    console.log("Total Inventory:", totalInventoryRounded);
                    this.form.b.assets.inventory = totalInventoryRounded;
    
                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalEstateValue = Array.isArray(estate)
                    ? estate.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.estateValue === 'number' ? item.estateValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalEstateValueRounded = Math.round(totalEstateValue * 100) / 100;
    
                    console.log("Total Estate Value:", totalEstateValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_estate_computed = totalEstateValueRounded;

                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalMachineryValue = Array.isArray(machinery)
                    ? machinery.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryValue === 'number' ? item.inventoryValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalMachineryValueRounded = Math.round(totalMachineryValue * 100) / 100;
    
                    console.log("Total Machinery Value:", totalMachineryValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_equipment_computed = totalMachineryValueRounded;

                    // Función para manejar valores no válidos
                    function safeValue(value) {
                        return isNaN(value) || value === undefined || value === null ? 0 : value;
                    }
                    // Sumar todos los valores sin errores
                    const totalIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0);
                    
                    // Sumar todos los valores sin errores
                    const totalAnotherIncomes = 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData.sumConsolidatedJournals || 0) + 
                        (agroData.sumConsolidatedSalaries || 0);


                    let agroIncomesParticipation = Math.round(
                        ((totalIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;

                    let agroExpensesParticipation = Math.round(
                        ((totalExpensesSum) 
                        / (totalIncomes)) * 100 * 100
                    ) / 100;

                    let agroAnotherIncomesParticipation = Math.round(
                        ((totalAnotherIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;

                    // Asegurar que totalizedFamiliarExpenses existe y no es null o undefined
                    const totalizedFamiliarExpenses = (cashFlowData_ && cashFlowData_.totalizedFamiliarExpenses !== undefined && cashFlowData_.totalizedFamiliarExpenses !== null) 
                        ? cashFlowData_.totalizedFamiliarExpenses 
                        : 0;

                    // Asegurar que loanPayment sea un número válido
                    const loanPayment = (agroData_ && agroData_.creditParameters && agroData_.creditParameters.loanPayment !== undefined && agroData_.creditParameters.loanPayment !== null) 
                        ? parseFloat(agroData_.creditParameters.loanPayment) 
                        : 0;

                    // Acceder a assessmentAmount sin `?.`
                    const assessmentAmount = (this.$store.state.assesments 
                        && this.$store.state.assesments[this.$store.state.actualAssesment] 
                        && this.$store.state.assesments[this.$store.state.actualAssesment].amount !== undefined)
                        ? this.$store.state.assesments[this.$store.state.actualAssesment].amount
                        : 0;
                    
                    // Asegurar que los valores existen y no son undefined o null
                    const totalPassivePatrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.total_passive_patrimony !== undefined)
                        ? this.form.b.passives.total_passive_patrimony
                        : 0;

                    const patrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.patrimony !== undefined && this.form.b.passives.patrimony !== 0)
                        ? this.form.b.passives.patrimony
                        : 1; // Evita división por 0

                    // Calcular financialIndicatorAgro1 de forma segura
                    let financialIndicatorAgro1 = (totalPassivePatrimony + assessmentAmount) / patrimony;

                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro1 = Math.round(financialIndicatorAgro1 * 100) / 100;

                    // Calcular financialIndicatorAgro de forma segura
                    let financialIndicatorAgro = 
                        (totalIncomesRounded - (totalExpensesSum + totalizedFamiliarExpenses) + assessmentAmount) / 
                        (loanPayment * clientTerm || 1); // Evita división por 0 si loanPayment es 0
                    
                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro2 = Math.round(financialIndicatorAgro * 100) / 100;

                    var dataConsolidated = {
                        incomes: {
                            totalIncomesRounded: totalIncomesRounded
                        },
                        expenses: {
                            totalSum: totalExpensesSum
                        },
                        others: {
                            
                        },
                        participations: {
                            agroIncomesParticipation: agroIncomesParticipation,
                            agroExpensesParticipation: agroExpensesParticipation,
                            agroAnotherIncomesParticipation: agroAnotherIncomesParticipation
                        }
                    }
                    this.setCashFlowBalance(dataConsolidated);
                }
            }
            else {
                this.showNotificationError('No estás en una sección permitida');
            }
        }
        else if(this.$store.state.isSpouse) {
            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType);
            this.productValidator(product);
            if (this.microcredit) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance.length != 0) {
                    // this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].transportCosts[0].totalTaxes);
                                    this.form.er.operative_expenses.taxes.locked = true;
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalInventory);
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value != 0) {
                            this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value;
                        }
                        else {
                            this.form.er.credit_sales = 0;
                        }
                    }
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            if (FinancialIndicators[i].restriction == null && !this.pyme) {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                            else if(this.pyme){
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                        }
                    }
                    if (this.form.cp.paymentCapacity.length == 0) {
                        if(this.pyme){
                            for (let i=0; i<PaymentCapacityPyme.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacityPyme[i].id ,
                                    name: PaymentCapacityPyme[i].name ,
                                    formula: PaymentCapacityPyme[i].formula,
                                    info: PaymentCapacityPyme[i].info,
                                    value: 0
                                })
                            }
                        }
                        if(!this.pyme){
                            for (let i=0; i<PaymentCapacity.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacity[i].id ,
                                    name: PaymentCapacity[i].name ,
                                    formula: PaymentCapacity[i].formula,
                                    info: PaymentCapacity[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].transportCosts[0].totalTaxes);
                                    this.form.er.operative_expenses.taxes.locked = true;
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalInventory);
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value != 0) {
                        this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value;
                    }
                    else {
                        this.form.er.credit_sales = 0;
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy > 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].extraPayment;
                        // this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].netSalary;
                    }
                }
            }
            else if(this.pyme){
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance.length != 0) {
                    // this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Otros gastos') {
                                this.form.er.operative_expenses.others.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.others.locked = true;
                                }
                            }
                        }

                        // Pyme
                        if(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].obligations.length > 0) {
                            let totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].totalTitular;
                            let totalObligationsCAV = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].totalObligationsCAV;
                            let financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].obligations;
                            // Tipos de obligación que queremos filtrar
                            const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                            const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                            const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                            const totals = this.sumObligations(financialObligations);
                            
                            
                            this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                            
                            this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
                            const sumSummarizedQuotas = summarizedQuotas["NEGOCIO"] + summarizedQuotas["BMM NEGOCIO"] + summarizedQuotas["PROVEEDOR"] + summarizedQuotas["OTRAS OBLIGA"];
                            

                            this.updateObligationResidue(totalObligationsCAV);
                            this.form.indebtness = totalObligations;
                            // 1. Filtra y suma por separado cada campo para las obligaciones de tipo "UNID FLIAR" y "TDC"
                            const unitFamilyTDCObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "TDC")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 2. Filtra y suma por separado cada campo para las obligaciones de tipo "TDC" o "CAV"
                            const tdcOrCavObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType != "TDC" && obligation.obligationAccountType != "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 3. Filtra y suma por separado cada campo solo para las obligaciones de tipo "CAV"
                            const cavOnlyObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            

                            // this.form.of.familiar.familiarObligations.forEach(obligation => {
                            //     if (obligation.obligationCreditor === 'Tarjeta de crédito') {
                            //         obligation.obligationResidue = unitFamilyTDCObligationsSum.residue;
                            //         obligation.obligationAmount = unitFamilyTDCObligationsSum.amount;
                            //         obligation.obligationPaymentValue = unitFamilyTDCObligationsSum.quota;
                            //         obligation.obligationTerm = unitFamilyTDCObligationsSum.pendingQuota;
                            //     } else if (obligation.obligationCreditor === 'Crédito consumo') {
                            //         obligation.obligationResidue = tdcOrCavObligationsSum.residue;
                            //         obligation.obligationAmount = tdcOrCavObligationsSum.amount;
                            //         obligation.obligationPaymentValue = tdcOrCavObligationsSum.quota;
                            //         obligation.obligationTerm = tdcOrCavObligationsSum.pendingQuota;
                            //     } else if (obligation.obligationCreditor === 'Crédito vivienda') {
                            //         obligation.obligationResidue = cavOnlyObligationsSum.residue;
                            //         obligation.obligationAmount = cavOnlyObligationsSum.amount;
                            //         obligation.obligationPaymentValue = cavOnlyObligationsSum.quota;
                            //         obligation.obligationTerm = cavOnlyObligationsSum.pendingQuota;
                            //     }
                            // });
                            this.form.of.business.obligations = [];
                            financialObligations.forEach(financialObligation => {
                                if(financialObligation.obligationType != 'UNID FLIAR'){
                                    this.form.of.business.obligations.push({
                                    obligationCreditor:  financialObligation.obligationEntity,
                                    obligationAmount: financialObligation.obligationAmountCredit,
                                    obligationPaymentValue: financialObligation.obligationQuota,
                                    obligationNumberPayments: financialObligation.obligationPendingQuota,
                                    obligationTerm: financialObligation.obligationTerm,
                                })
                                }
                            });

                        }
                        // Pyme
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalInventory);
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value != 0) {
                            this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value;
                        }
                        else {
                            this.form.er.credit_sales = 0;
                        }
                    }
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            if (FinancialIndicators[i].restriction == null && !this.pyme) {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                            else if(this.pyme){
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                        }
                    }
                    if (this.form.cp.paymentCapacity.length == 0) {
                        if(this.pyme){
                            for (let i=0; i<PaymentCapacityPyme.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacityPyme[i].id ,
                                    name: PaymentCapacityPyme[i].name ,
                                    formula: PaymentCapacityPyme[i].formula,
                                    info: PaymentCapacityPyme[i].info,
                                    value: 0
                                })
                            }
                        }
                        if(!this.pyme){
                            for (let i=0; i<PaymentCapacity.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacity[i].id ,
                                    name: PaymentCapacity[i].name ,
                                    formula: PaymentCapacity[i].formula,
                                    info: PaymentCapacity[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Otros gastos') {
                                this.form.er.operative_expenses.others.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.others.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalInventory);
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value != 0) {
                        this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].creditSales.value;
                    }
                    else {
                        this.form.er.credit_sales = 0;
                    }
                    // Pyme
                    if(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].obligations.length > 0) {
                            let totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].totalTitular;
                            let totalObligationsCAV = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].totalObligationsCAV;
                            let financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].financialObligations[0].obligations;
                            // Tipos de obligación que queremos filtrar
                            const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                            const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                            const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                            const totals = this.sumObligations(financialObligations);
                            
                            
                            this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                            
                            this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
                            const sumSummarizedQuotas = summarizedQuotas["NEGOCIO"] + summarizedQuotas["BMM NEGOCIO"] + summarizedQuotas["PROVEEDOR"] + summarizedQuotas["OTRAS OBLIGA"];
                            

                            this.updateObligationResidue(totalObligationsCAV);
                            this.form.indebtness = totalObligations;
                            // 1. Filtra y suma por separado cada campo para las obligaciones de tipo "UNID FLIAR" y "TDC"
                            const unitFamilyTDCObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "TDC")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 2. Filtra y suma por separado cada campo para las obligaciones de tipo "TDC" o "CAV"
                            const tdcOrCavObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType != "TDC" && obligation.obligationAccountType != "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 3. Filtra y suma por separado cada campo solo para las obligaciones de tipo "CAV"
                            const cavOnlyObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            

                            // this.form.of.familiar.familiarObligations.forEach(obligation => {
                            //     if (obligation.obligationCreditor === 'Tarjeta de crédito') {
                            //         obligation.obligationResidue = unitFamilyTDCObligationsSum.residue;
                            //         obligation.obligationAmount = unitFamilyTDCObligationsSum.amount;
                            //         obligation.obligationPaymentValue = unitFamilyTDCObligationsSum.quota;
                            //         obligation.obligationTerm = unitFamilyTDCObligationsSum.pendingQuota;
                            //     } else if (obligation.obligationCreditor === 'Crédito consumo') {
                            //         obligation.obligationResidue = tdcOrCavObligationsSum.residue;
                            //         obligation.obligationAmount = tdcOrCavObligationsSum.amount;
                            //         obligation.obligationPaymentValue = tdcOrCavObligationsSum.quota;
                            //         obligation.obligationTerm = tdcOrCavObligationsSum.pendingQuota;
                            //     } else if (obligation.obligationCreditor === 'Crédito vivienda') {
                            //         obligation.obligationResidue = cavOnlyObligationsSum.residue;
                            //         obligation.obligationAmount = cavOnlyObligationsSum.amount;
                            //         obligation.obligationPaymentValue = cavOnlyObligationsSum.quota;
                            //         obligation.obligationTerm = cavOnlyObligationsSum.pendingQuota;
                            //     }
                            // });
                            this.form.of.business.obligations = [];
                            financialObligations.forEach(financialObligation => {
                                if(financialObligation.obligationType != 'UNID FLIAR'){
                                    this.form.of.business.obligations.push({
                                    obligationCreditor:  financialObligation.obligationEntity,
                                    obligationAmount: financialObligation.obligationAmountCredit,
                                    obligationPaymentValue: financialObligation.obligationQuota,
                                    obligationNumberPayments: financialObligation.obligationPendingQuota,
                                    obligationTerm: financialObligation.obligationTerm,
                                })
                                }
                            });

                        }
                    // Pyme
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy > 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].extraPayment;
                        // this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy-1].netSalary;
                    }
                }
            }
            else {
                this.showNotificationError('No estás en una sección permitida');
            }
        }
        if (this.$store.state.isGuarantor) {
            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType);
            this.productValidator(product);
            if (this.microcredit) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts[0].totalTaxes);
                                    this.form.er.operative_expenses.taxes.locked = true;
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalInventory);
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value != 0) {
                            this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value;
                        }
                        else {
                            this.form.er.credit_sales = 0;
                        }
                    }
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            if (FinancialIndicators[i].restriction == null && !this.pyme) {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                            else if(this.pyme){
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                        }
                    }
                    if (this.form.cp.paymentCapacity.length == 0) {
                        if(this.pyme){
                            for (let i=0; i<PaymentCapacityPyme.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacityPyme[i].id ,
                                    name: PaymentCapacityPyme[i].name ,
                                    formula: PaymentCapacityPyme[i].formula,
                                    info: PaymentCapacityPyme[i].info,
                                    value: 0
                                })
                            }
                        }
                        if(!this.pyme){
                            for (let i=0; i<PaymentCapacity.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacity[i].id ,
                                    name: PaymentCapacity[i].name ,
                                    formula: PaymentCapacity[i].formula,
                                    info: PaymentCapacity[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = Math.round(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts[0].totalTaxes);
                                    this.form.er.operative_expenses.taxes.locked = true;
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalInventory);
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value != 0) {
                        this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value;
                    }
                    else {
                        this.form.er.credit_sales = 0;
                    }
                }
                if ((this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1) > 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        // this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].extraPayment;
                        // this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].netSalary;
                    }
                }
                
            }
            else if(this.pyme) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Otros gastos') {
                                this.form.er.operative_expenses.others.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.others.locked = true;
                                }
                            }
                        }
                        // Pyme
                        if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].obligations.length > 0) {
                            let totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].totalTitular;
                            let totalObligationsCAV = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].totalObligationsCAV;
                            let financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].obligations;
                            // Tipos de obligación que queremos filtrar
                            const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                            const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                            const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                            const totals = this.sumObligations(financialObligations);
                            
                            
                            this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                            
                            this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
                            const sumSummarizedQuotas = summarizedQuotas["NEGOCIO"] + summarizedQuotas["BMM NEGOCIO"] + summarizedQuotas["PROVEEDOR"] + summarizedQuotas["OTRAS OBLIGA"];
                            
                                
                            this.form.if.personalExpenses.forEach(expense => {
                                if (expense.personalExpenseName === 'Cuotas créditos recibidos por la UF') {
                                    expense.personalExpenseValue = summarizedQuotas["UNID FLIAR"];
                                }
                            });

                            this.updateObligationResidue(totalObligationsCAV);
                            this.form.indebtness = totalObligations;
                            // 1. Filtra y suma por separado cada campo para las obligaciones de tipo "UNID FLIAR" y "TDC"
                            const unitFamilyTDCObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "TDC")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 2. Filtra y suma por separado cada campo para las obligaciones de tipo "TDC" o "CAV"
                            const tdcOrCavObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType != "TDC" && obligation.obligationAccountType != "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 3. Filtra y suma por separado cada campo solo para las obligaciones de tipo "CAV"
                            const cavOnlyObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            
                            

                            this.form.of.familiar.familiarObligations.forEach(obligation => {
                                if (obligation.obligationCreditor === 'Tarjeta de crédito') {
                                    obligation.obligationResidue = unitFamilyTDCObligationsSum.residue;
                                    obligation.obligationAmount = unitFamilyTDCObligationsSum.amount;
                                    obligation.obligationPaymentValue = unitFamilyTDCObligationsSum.quota;
                                    obligation.obligationTerm = unitFamilyTDCObligationsSum.pendingQuota;
                                } else if (obligation.obligationCreditor === 'Crédito consumo') {
                                    obligation.obligationResidue = tdcOrCavObligationsSum.residue;
                                    obligation.obligationAmount = tdcOrCavObligationsSum.amount;
                                    obligation.obligationPaymentValue = tdcOrCavObligationsSum.quota;
                                    obligation.obligationTerm = tdcOrCavObligationsSum.pendingQuota;
                                } else if (obligation.obligationCreditor === 'Crédito vivienda') {
                                    obligation.obligationResidue = cavOnlyObligationsSum.residue;
                                    obligation.obligationAmount = cavOnlyObligationsSum.amount;
                                    obligation.obligationPaymentValue = cavOnlyObligationsSum.quota;
                                    obligation.obligationTerm = cavOnlyObligationsSum.pendingQuota;
                                }
                            });
                            this.form.of.business.obligations = [];
                            financialObligations.forEach(financialObligation => {
                                if(financialObligation.obligationType != 'UNID FLIAR'){
                                    this.form.of.business.obligations.push({
                                    obligationCreditor:  financialObligation.obligationEntity,
                                    obligationAmount: financialObligation.obligationAmountCredit,
                                    obligationPaymentValue: financialObligation.obligationQuota,
                                    obligationNumberPayments: financialObligation.obligationPendingQuota,
                                    obligationTerm: financialObligation.obligationTerm,
                                })
                                }
                            });

                        }
                        // Pyme
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalInventory);
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value != 0) {
                            this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value;
                        }
                        else {
                            this.form.er.credit_sales = 0;
                        }
                    }
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            if (FinancialIndicators[i].restriction == null && !this.pyme) {
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                            else if(this.pyme){
                                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                if (subcategory == 'transporte') {
                                    if ( FinancialIndicators[i].name != 'Rotación Inventario') {
                                        this.form.i.financialIndicators.push({
                                            id: FinancialIndicators[i].id ,
                                            name: FinancialIndicators[i].name ,
                                            alert: FinancialIndicators[i].alert ,
                                            unit: FinancialIndicators[i]. unit,
                                            formula: FinancialIndicators[i].formula,
                                            info: FinancialIndicators[i].info,
                                            value: 0
                                        })
                                    }
                                }
                                else {
                                    this.form.i.financialIndicators.push({
                                        id: FinancialIndicators[i].id ,
                                        name: FinancialIndicators[i].name ,
                                        alert: FinancialIndicators[i].alert ,
                                        unit: FinancialIndicators[i]. unit,
                                        formula: FinancialIndicators[i].formula,
                                        info: FinancialIndicators[i].info,
                                        value: 0
                                    })
                                }
                            }
                        }
                    }
                    if (this.form.cp.paymentCapacity.length == 0) {
                        if(this.pyme){
                            for (let i=0; i<PaymentCapacityPyme.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacityPyme[i].id ,
                                    name: PaymentCapacityPyme[i].name ,
                                    formula: PaymentCapacityPyme[i].formula,
                                    info: PaymentCapacityPyme[i].info,
                                    value: 0
                                })
                            }
                        }
                        if(!this.pyme){
                            for (let i=0; i<PaymentCapacity.length;i++) {
                                this.form.cp.paymentCapacity.push({
                                    id: PaymentCapacity[i].id ,
                                    name: PaymentCapacity[i].name ,
                                    formula: PaymentCapacity[i].formula,
                                    info: PaymentCapacity[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        this.form.er.account_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales;
                        this.form.er.sales_costs = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalCost;
                        // this.form.er.operative_expenses.others = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOperatingExpenses;
                        var expenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].operatingExpenses;
                        var periodicity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].periodicityOperatingExpenses;
                        var days = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].daysOperatingExpenses;
                        var flag = 0;
                        if (periodicity == 'Diaria') {
                            if(days != 0) {
                                flag = parseInt(days)* 4;
                            }
                        }
                        else if (periodicity == 'Semanal') {
                            flag = 4;
                        }
                        else if (periodicity == 'Mensual') {
                            flag = 1;
                        }
                        for (let i=0; i<expenses.length; i++) {
                            if (expenses[i].name == 'Salarios') {
                                this.form.er.operative_expenses.salaries.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.salaries.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Servicios públicos') {
                                this.form.er.operative_expenses.public_services.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.public_services.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Impuestos') {
                                if (subcategory == 'transporte') {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                    
                                }
                                else {
                                    this.form.er.operative_expenses.taxes.value = expenses[i].value * flag;
                                    if(expenses[i].value * flag != 0) {
                                        this.form.er.operative_expenses.taxes.locked = true;
                                    }
                                }
                            }
                            else if (expenses[i].name == 'Transporte') {
                                this.form.er.operative_expenses.transport.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.transport.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Gastos financieros') {
                                this.form.er.operative_expenses.financial_expenses.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.financial_expenses.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Alquiler') {
                                this.form.er.operative_expenses.rental.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.rental.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Imprevistos') {
                                this.form.er.operative_expenses.incidentals.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.incidentals.locked = true;
                                }
                            }
                            else if (expenses[i].name == 'Otros gastos') {
                                this.form.er.operative_expenses.others.value = expenses[i].value * flag;
                                if(expenses[i].value * flag != 0) {
                                    this.form.er.operative_expenses.others.locked = true;
                                }
                            }
                        }
                        this.form.er.operative_expenses.others.value = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses);
                        if (parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses) != 0) {
                            this.form.er.operative_expenses.others.value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalOthersOperatingExpenses;
                        }
                        this.form.b.assets.inventory = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalInventory);
                    }
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value != 0) {
                        this.form.er.credit_sales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].creditSales.value;
                    }
                    else {
                        this.form.er.credit_sales = 0;
                    }
                    // Pyme
                    if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].obligations.length > 0) {
                            let totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].totalTitular;
                            let totalObligationsCAV = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].totalObligationsCAV;
                            let financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].financialObligations[0].obligations;
                            // Tipos de obligación que queremos filtrar
                            const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                            const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                            const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                            const totals = this.sumObligations(financialObligations);
                            
                            
                            this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                            
                            this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                            
                            this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                            
                            this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
                            const sumSummarizedQuotas = summarizedQuotas["NEGOCIO"] + summarizedQuotas["BMM NEGOCIO"] + summarizedQuotas["PROVEEDOR"] + summarizedQuotas["OTRAS OBLIGA"];
                            
                            
                                
                            this.form.if.personalExpenses.forEach(expense => {
                                if (expense.personalExpenseName === 'Cuotas créditos recibidos por la UF') {
                                    expense.personalExpenseValue = summarizedQuotas["UNID FLIAR"];
                                }
                            });

                            this.updateObligationResidue(totalObligationsCAV);
                            this.form.indebtness = totalObligations;
                            // 1. Filtra y suma por separado cada campo para las obligaciones de tipo "UNID FLIAR" y "TDC"
                            const unitFamilyTDCObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "TDC")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 2. Filtra y suma por separado cada campo para las obligaciones de tipo "TDC" o "CAV"
                            const tdcOrCavObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType != "TDC" && obligation.obligationAccountType != "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            // 3. Filtra y suma por separado cada campo solo para las obligaciones de tipo "CAV"
                            const cavOnlyObligationsSum = financialObligations
                                .filter(obligation => obligation.obligationType === "UNID FLIAR" && obligation.obligationAccountType === "CAV")
                                .reduce((sum, obligation) => {
                                    sum.residue += (obligation.obligationResidue || 0);
                                    sum.amount += (obligation.obligationAmountCredit || 0);
                                    sum.quota += (obligation.obligationQuota || 0);
                                    sum.pendingQuota += (parseInt(obligation.obligationPendingQuota) || 0);
                                    return sum;
                                }, { residue: 0, amount: 0, quota: 0, pendingQuota: 0 });

                            

                            this.form.of.familiar.familiarObligations.forEach(obligation => {
                                if (obligation.obligationCreditor === 'Tarjeta de crédito') {
                                    obligation.obligationResidue = unitFamilyTDCObligationsSum.residue;
                                    obligation.obligationAmount = unitFamilyTDCObligationsSum.amount;
                                    obligation.obligationPaymentValue = unitFamilyTDCObligationsSum.quota;
                                    obligation.obligationTerm = unitFamilyTDCObligationsSum.pendingQuota;
                                } else if (obligation.obligationCreditor === 'Crédito consumo') {
                                    obligation.obligationResidue = tdcOrCavObligationsSum.residue;
                                    obligation.obligationAmount = tdcOrCavObligationsSum.amount;
                                    obligation.obligationPaymentValue = tdcOrCavObligationsSum.quota;
                                    obligation.obligationTerm = tdcOrCavObligationsSum.pendingQuota;
                                } else if (obligation.obligationCreditor === 'Crédito vivienda') {
                                    obligation.obligationResidue = cavOnlyObligationsSum.residue;
                                    obligation.obligationAmount = cavOnlyObligationsSum.amount;
                                    obligation.obligationPaymentValue = cavOnlyObligationsSum.quota;
                                    obligation.obligationTerm = cavOnlyObligationsSum.pendingQuota;
                                }
                            });
                            this.form.of.business.obligations = [];
                            financialObligations.forEach(financialObligation => {
                                if(financialObligation.obligationType != 'UNID FLIAR'){
                                    this.form.of.business.obligations.push({
                                    obligationCreditor:  financialObligation.obligationEntity,
                                    obligationAmount: financialObligation.obligationAmountCredit,
                                    obligationPaymentValue: financialObligation.obligationQuota,
                                    obligationNumberPayments: financialObligation.obligationPendingQuota,
                                    obligationTerm: financialObligation.obligationTerm,
                                })
                                }
                            });

                        }
                        // Pyme
                }
                if ((this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1) > 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        // this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].extraPayment;
                        // this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy-1].netSalary;
                    }
                }
                
            }
            else if(this.agro){
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                    let anotherExpenses = null;
                    let cashFlow = null;
                    let cashFlowData = null;
                    let estate = null;
                    let expenses = null;
                    let financialObligations = null;
                    let historicalYields = null;
                    let inventory = null;
                    let labour = null;
                    let machinery = null;
                    let product = null;
                    let salary = null;
                    let seasonalSales = null;
                    let totalObligations = 0;
                    if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations){
                        totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations[0].totalTitular;
                        financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations[0].obligations;
                    }
                    else {
                        totalObligations = 0;
                        financialObligations = [];
                    }
                    this.form.indebtness = totalObligations;
                    let agroData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData;
                    anotherExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.anotherExpenses;
                    cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlow;
                    cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
                    estate = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.estate;
                    expenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.expenses;
                    historicalYields = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.historicalYields;
                    inventory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.inventory;
                    labour = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.labour;
                    machinery = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.machinery;
                    product = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.product;
                    salary = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.salary;
                    seasonalSales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.seasonalSales;
                    
                    // Tipos de obligación que queremos filtrar
                    const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                    const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                    const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                    const totals = this.sumObligations(financialObligations);
                    
                    this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                    
                    this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
    
                    const clientTerm = parseInt(cashFlow.clientTerm, 10);
                    const state = this.$store.state;
                    const assesments = state.assesments || {};
                    const actualAssesment = assesments[state.actualAssesment] || {};
                    const customer = actualAssesment.guarantors[0] || {};
                    const studies = customer.studies || {};
                    const actualStudy = studies[customer.actualStudy] || {};
                    const agroData_ = actualStudy.agroData || {};
                    const cashFlowData_ = agroData_.cashFlowData || {};
                    const microBalance = agroData_.microBalance || {};
                    const spouseBalance = agroData_.spouseBalance || {};

                    // Asegurar que totalizedYields sea tratado correctamente
                    const totalizedYields = cashFlowData_.totalizedYields && typeof cashFlowData_.totalizedYields === 'object'
                        ? Object.keys(cashFlowData_.totalizedYields).map(key => cashFlowData_.totalizedYields[key] || 0)
                        : [0, 0, 0, 0, 0];

                    // Asegurar que totalizedSeasonalSales sea tratado correctamente
                    const totalizedSeasonalSales = cashFlowData_.totalizedSeasonalSales && typeof cashFlowData_.totalizedSeasonalSales === 'object'
                        ? Object.keys(cashFlowData_.totalizedSeasonalSales).map(key => 
                            (cashFlowData_.totalizedSeasonalSales[key] && cashFlowData_.totalizedSeasonalSales[key].total) || 0)
                        : [0, 0, 0, 0, 0];

                    // Sumar todos los valores sin errores
                    const totalSumIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0) + 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData_.sumConsolidatedJournals || 0) + 
                        (agroData_.sumConsolidatedSalaries || 0);
                    
                    const totalIncomesRounded = Math.round(totalSumIncomes * 100) / 100;
    
                    // Aplicar la lógica según el valor de clientTerm
                    const divisor = clientTerm > 24 ? 25 : clientTerm + 1;
                    const adjustedIncome = totalIncomesRounded / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedIncomeRounded = Math.round(adjustedIncome * 100) / 100;
    
                    console.log("Adjusted Income:", adjustedIncomeRounded);
                    // this.form.er.account_sales = adjustedIncomeRounded;
                    this.$set(this.form.er, 'account_sales', adjustedIncomeRounded);
    
                    const totalizedExpenses = cashFlowData_.totalizedExpenses || {};

                    // Verificar si son arrays antes de acceder a los valores
                    const historicalExpenses = Array.isArray(totalizedExpenses.historical)
                        ? totalizedExpenses.historical.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    const seasonalExpenses = Array.isArray(totalizedExpenses.seasonal)
                        ? totalizedExpenses.seasonal.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    // Acceder a valores únicos de forma segura
                    const totalizedLabour = cashFlowData_.totalizedLabour || 0;
                    const totalizedAnotherExpenses = cashFlowData_.totalizedAnotherExpenses || 0;
                    const totalizedFinancialObligationsByMonth = cashFlowData_.totalizedFinancialObligationsByMonth || 0;

                    // Sumar todos los valores sin errores
                    const totalExpensesSum =
                        (historicalExpenses[0] || 0) +
                        (historicalExpenses[1] || 0) +
                        (historicalExpenses[2] || 0) +
                        (historicalExpenses[3] || 0) +
                        (historicalExpenses[4] || 0) +
                        (seasonalExpenses[0] || 0) +
                        (seasonalExpenses[1] || 0) +
                        (seasonalExpenses[2] || 0) +
                        (seasonalExpenses[3] || 0) +
                        (seasonalExpenses[4] || 0) +
                        totalizedLabour +
                        totalizedAnotherExpenses + 
                        totalizedFinancialObligationsByMonth;

                    // Mostrar valores en la consola
                    console.log("Gastos históricos:", historicalExpenses);
                    console.log("Gastos estacionales:", seasonalExpenses);
                    console.log("Totalized Labour:", totalizedLabour);
                    console.log("Totalized Another Expenses:", totalizedAnotherExpenses);
                    console.log("Suma total de todos los gastos:", totalExpensesSum);
    
                    // Aplicar la fórmula de ajuste, si clientTerm > 24, dividir entre 25, si no entre clientTerm + 1
                    const adjustedTotal = totalExpensesSum / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedTotalRounded = Math.round(adjustedTotal * 100) / 100;
    
                    console.log("Adjusted Total:", adjustedTotalRounded);
                    // this.form.er.sales_costs = adjustedTotalRounded;
                    this.form.er.credit_sales = 0;
                    this.$set(this.form.er, 'sales_costs', adjustedTotalRounded);
    
                    // Calcular la suma de todos los inventarios, manejando datos inválidos
                    const totalInventory = Array.isArray(inventory)
                    ? inventory.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryTotal === 'number' ? item.inventoryTotal : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalInventoryRounded = Math.round(totalInventory * 100) / 100;
    
                    console.log("Total Inventory:", totalInventoryRounded);
                    this.form.b.assets.inventory = totalInventoryRounded;
    
                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalEstateValue = Array.isArray(estate)
                    ? estate.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.estateValue === 'number' ? item.estateValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalEstateValueRounded = Math.round(totalEstateValue * 100) / 100;
    
                    console.log("Total Estate Value:", totalEstateValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_estate_computed = totalEstateValueRounded;

                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalMachineryValue = Array.isArray(machinery)
                    ? machinery.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryValue === 'number' ? item.inventoryValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalMachineryValueRounded = Math.round(totalMachineryValue * 100) / 100;
    
                    console.log("Total Machinery Value:", totalMachineryValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_equipment_computed = totalMachineryValueRounded;

                    // Función para manejar valores no válidos
                    function safeValue(value) {
                        return isNaN(value) || value === undefined || value === null ? 0 : value;
                    }
                    // Sumar todos los valores sin errores
                    const totalIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0);
                    
                    // Sumar todos los valores sin errores
                    const totalAnotherIncomes = 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData.sumConsolidatedJournals || 0) + 
                        (agroData.sumConsolidatedSalaries || 0);


                    let agroIncomesParticipation = Math.round(
                        ((totalIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;

                    let agroExpensesParticipation = Math.round(
                        ((totalExpensesSum) 
                        / (totalIncomes)) * 100 * 100
                    ) / 100;

                    let agroAnotherIncomesParticipation = Math.round(
                        ((totalAnotherIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;

                    // Asegurar que totalizedFamiliarExpenses existe y no es null o undefined
                    const totalizedFamiliarExpenses = (cashFlowData_ && cashFlowData_.totalizedFamiliarExpenses !== undefined && cashFlowData_.totalizedFamiliarExpenses !== null) 
                        ? cashFlowData_.totalizedFamiliarExpenses 
                        : 0;

                    // Asegurar que loanPayment sea un número válido
                    const loanPayment = (agroData_ && agroData_.creditParameters && agroData_.creditParameters.loanPayment !== undefined && agroData_.creditParameters.loanPayment !== null) 
                        ? parseFloat(agroData_.creditParameters.loanPayment) 
                        : 0;

                    // Acceder a assessmentAmount sin `?.`
                    const assessmentAmount = (this.$store.state.assesments 
                        && this.$store.state.assesments[this.$store.state.actualAssesment] 
                        && this.$store.state.assesments[this.$store.state.actualAssesment].amount !== undefined)
                        ? this.$store.state.assesments[this.$store.state.actualAssesment].amount
                        : 0;
                    
                    // Asegurar que los valores existen y no son undefined o null
                    const totalPassivePatrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.total_passive_patrimony !== undefined)
                        ? this.form.b.passives.total_passive_patrimony
                        : 0;

                    const patrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.patrimony !== undefined && this.form.b.passives.patrimony !== 0)
                        ? this.form.b.passives.patrimony
                        : 1; // Evita división por 0

                    // Calcular financialIndicatorAgro1 de forma segura
                    let financialIndicatorAgro1 = (totalPassivePatrimony + assessmentAmount) / patrimony;

                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro1 = Math.round(financialIndicatorAgro1 * 100) / 100;

                    // Calcular financialIndicatorAgro de forma segura
                    let financialIndicatorAgro = 
                        (totalIncomesRounded - (totalExpensesSum + totalizedFamiliarExpenses) + assessmentAmount) / 
                        (loanPayment * clientTerm || 1); // Evita división por 0 si loanPayment es 0
                    
                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro2 = Math.round(financialIndicatorAgro * 100) / 100;

                    var dataConsolidated = {
                        incomes: {
                            totalIncomesRounded: totalIncomesRounded
                        },
                        expenses: {
                            totalSum: totalExpensesSum
                        },
                        others: {
                            
                        },
                        participations: {
                            agroIncomesParticipation: agroIncomesParticipation,
                            agroExpensesParticipation: agroExpensesParticipation,
                            agroAnotherIncomesParticipation: agroAnotherIncomesParticipation
                        }
                    }
                    this.setCashFlowBalance(dataConsolidated);
                }
                else {
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicatorsAgro.length;i++) {
                            if (FinancialIndicatorsAgro[i].restriction == 'AG') {
                                this.form.i.financialIndicators.push({
                                    id: FinancialIndicatorsAgro[i].id ,
                                    name: FinancialIndicatorsAgro[i].name ,
                                    alert: FinancialIndicatorsAgro[i].alert ,
                                    unit: FinancialIndicatorsAgro[i]. unit,
                                    formula: FinancialIndicatorsAgro[i].formula,
                                    info: FinancialIndicatorsAgro[i].info,
                                    value: 0
                                })
                            }
                        }
                    }
                    let anotherExpenses = null;
                    let cashFlow = null;
                    let cashFlowData = null;
                    let estate = null;
                    let expenses = null;
                    let financialObligations = null;
                    let historicalYields = null;
                    let inventory = null;
                    let labour = null;
                    let machinery = null;
                    let product = null;
                    let salary = null;
                    let seasonalSales = null;
                    let totalObligations = 0;
                    if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations){
                        totalObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations[0].totalTitular;
                        financialObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations[0].obligations;
                    }
                    else {
                        totalObligations = 0;
                        financialObligations = [];
                    }
                    this.form.indebtness = totalObligations;
                    let agroData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData;
                    anotherExpenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.anotherExpenses;
                    cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlow;
                    cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
                    estate = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.estate;
                    expenses = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.expenses;
                    historicalYields = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.historicalYields;
                    inventory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.inventory;
                    labour = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.labour;
                    machinery = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.machinery;
                    product = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.product;
                    salary = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.salary;
                    seasonalSales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.seasonalSales;
                    
                    // Tipos de obligación que queremos filtrar
                    const obligationTypes = ["NEGOCIO", "BMM NEGOCIO", "PROVEEDOR", "UNID FLIAR", "OTRAS OBLIGA"];
                    const summarizedObligations = this.filterAndSumObligationsByType(financialObligations, obligationTypes);
                    const summarizedQuotas = this.filterAndSumQuotasByType(financialObligations, obligationTypes);
                    const totals = this.sumObligations(financialObligations);
                    
                    this.form.b.passives.banks_credits = summarizedObligations["NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.banks_credits_fixed_assets = summarizedObligations["NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.BMM_credits = summarizedObligations["BMM NEGOCIO"].capitalTrabajoResidue;
                    
                    this.form.b.passives.BMM_credits_fixed_assets = summarizedObligations["BMM NEGOCIO"].activoFijoResidue;
                    
                    this.form.b.passives.accounts_payable_suppliers = summarizedObligations["PROVEEDOR"].capitalTrabajoResidue;
                    
                    this.form.b.passives.others_fixed_assets = summarizedObligations["OTRAS OBLIGA"].activoFijoResidue
    
                    const clientTerm = parseInt(cashFlow.clientTerm, 10);
                    const state = this.$store.state;
                    const assesments = state.assesments || {};
                    const actualAssesment = assesments[state.actualAssesment] || {};
                    const customer = actualAssesment.guarantors[0] || {};
                    const studies = customer.studies || {};
                    const actualStudy = studies[customer.actualStudy] || {};
                    const agroData_ = actualStudy.agroData || {};
                    const cashFlowData_ = agroData_.cashFlowData || {};
                    const microBalance = agroData_.microBalance || {};
                    const spouseBalance = agroData_.spouseBalance || {};

                    // Asegurar que totalizedYields sea tratado correctamente
                    const totalizedYields = cashFlowData_.totalizedYields && typeof cashFlowData_.totalizedYields === 'object'
                        ? Object.keys(cashFlowData_.totalizedYields).map(key => cashFlowData_.totalizedYields[key] || 0)
                        : [0, 0, 0, 0, 0];

                    // Asegurar que totalizedSeasonalSales sea tratado correctamente
                    const totalizedSeasonalSales = cashFlowData_.totalizedSeasonalSales && typeof cashFlowData_.totalizedSeasonalSales === 'object'
                        ? Object.keys(cashFlowData_.totalizedSeasonalSales).map(key => 
                            (cashFlowData_.totalizedSeasonalSales[key] && cashFlowData_.totalizedSeasonalSales[key].total) || 0)
                        : [0, 0, 0, 0, 0];

                    // Sumar todos los valores sin errores
                    const totalSumIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0) + 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData_.sumConsolidatedJournals || 0) + 
                        (agroData_.sumConsolidatedSalaries || 0);
                    
                    const totalIncomesRounded = Math.round(totalSumIncomes * 100) / 100;
    
                    // Aplicar la lógica según el valor de clientTerm
                    const divisor = clientTerm > 24 ? 25 : clientTerm + 1;
                    const adjustedIncome = totalIncomesRounded / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedIncomeRounded = Math.round(adjustedIncome * 100) / 100;
    
                    console.log("Adjusted Income:", adjustedIncomeRounded);
                    // this.form.er.account_sales = adjustedIncomeRounded;
                    this.$set(this.form.er, 'account_sales', adjustedIncomeRounded);
    
                    const totalizedExpenses = cashFlowData_.totalizedExpenses || {};

                    // Verificar si son arrays antes de acceder a los valores
                    const historicalExpenses = Array.isArray(totalizedExpenses.historical)
                        ? totalizedExpenses.historical.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    const seasonalExpenses = Array.isArray(totalizedExpenses.seasonal)
                        ? totalizedExpenses.seasonal.map(expense => (expense && expense.totalizedExpense) || 0)
                        : [0, 0, 0, 0, 0];

                    // Acceder a valores únicos de forma segura
                    const totalizedLabour = cashFlowData_.totalizedLabour || 0;
                    const totalizedAnotherExpenses = cashFlowData_.totalizedAnotherExpenses || 0;
                    const totalizedFinancialObligationsByMonth = cashFlowData_.totalizedFinancialObligationsByMonth || 0;

                    // Sumar todos los valores sin errores
                    const totalExpensesSum =
                        (historicalExpenses[0] || 0) +
                        (historicalExpenses[1] || 0) +
                        (historicalExpenses[2] || 0) +
                        (historicalExpenses[3] || 0) +
                        (historicalExpenses[4] || 0) +
                        (seasonalExpenses[0] || 0) +
                        (seasonalExpenses[1] || 0) +
                        (seasonalExpenses[2] || 0) +
                        (seasonalExpenses[3] || 0) +
                        (seasonalExpenses[4] || 0) +
                        totalizedLabour +
                        totalizedAnotherExpenses + 
                        totalizedFinancialObligationsByMonth;

                    // Mostrar valores en la consola
                    console.log("Gastos históricos:", historicalExpenses);
                    console.log("Gastos estacionales:", seasonalExpenses);
                    console.log("Totalized Labour:", totalizedLabour);
                    console.log("Totalized Another Expenses:", totalizedAnotherExpenses);
                    console.log("Suma total de todos los gastos:", totalExpensesSum);
    
                    // Aplicar la fórmula de ajuste, si clientTerm > 24, dividir entre 25, si no entre clientTerm + 1
                    const adjustedTotal = totalExpensesSum / divisor;
    
                    // Redondear el resultado a 2 decimales
                    const adjustedTotalRounded = Math.round(adjustedTotal * 100) / 100;
    
                    console.log("Adjusted Total:", adjustedTotalRounded);
                    // this.form.er.sales_costs = adjustedTotalRounded;
                    this.form.er.credit_sales = 0;
                    this.$set(this.form.er, 'sales_costs', adjustedTotalRounded);
    
                    // Calcular la suma de todos los inventarios, manejando datos inválidos
                    const totalInventory = Array.isArray(inventory)
                    ? inventory.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryTotal === 'number' ? item.inventoryTotal : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalInventoryRounded = Math.round(totalInventory * 100) / 100;
    
                    console.log("Total Inventory:", totalInventoryRounded);
                    this.form.b.assets.inventory = totalInventoryRounded;
    
                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalEstateValue = Array.isArray(estate)
                    ? estate.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.estateValue === 'number' ? item.estateValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalEstateValueRounded = Math.round(totalEstateValue * 100) / 100;
    
                    console.log("Total Estate Value:", totalEstateValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_estate_computed = totalEstateValueRounded;

                    // Calcular la suma de todos los valores de estateValue, manejando datos inválidos
                    const totalMachineryValue = Array.isArray(machinery)
                    ? machinery.reduce(
                        (accumulator, item) => accumulator + (item && typeof item.inventoryValue === 'number' ? item.inventoryValue : 0),
                        0
                        )
                    : 0;

    
                    // Redondear el resultado a 2 decimales
                    const totalMachineryValueRounded = Math.round(totalMachineryValue * 100) / 100;
    
                    console.log("Total Machinery Value:", totalMachineryValueRounded);
                    // Asignamos el valor total a la propiedad computada form_estate_computed
                    this.form_equipment_computed = totalMachineryValueRounded;

                    // Función para manejar valores no válidos
                    function safeValue(value) {
                        return isNaN(value) || value === undefined || value === null ? 0 : value;
                    }
                    // Sumar todos los valores sin errores
                    const totalIncomes = 
                        (totalizedYields[0] || 0) + 
                        (totalizedYields[1] || 0) + 
                        (totalizedYields[2] || 0) + 
                        (totalizedYields[3] || 0) + 
                        (totalizedYields[4] || 0) + 
                        (totalizedSeasonalSales[0] || 0) + 
                        (totalizedSeasonalSales[1] || 0) + 
                        (totalizedSeasonalSales[2] || 0) + 
                        (totalizedSeasonalSales[3] || 0) + 
                        (totalizedSeasonalSales[4] || 0) + 
                        (cashFlowData_.totalProducts || 0);
                    
                    // Sumar todos los valores sin errores
                    const totalAnotherIncomes = 
                        (microBalance.totalOperatingUtility || 0) + 
                        (spouseBalance.spouseTotal || 0) + 
                        (agroData.sumConsolidatedJournals || 0) + 
                        (agroData.sumConsolidatedSalaries || 0);


                    let agroIncomesParticipation = Math.round(
                        ((totalIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;

                    let agroExpensesParticipation = Math.round(
                        ((totalExpensesSum) 
                        / (totalIncomes)) * 100 * 100
                    ) / 100;

                    let agroAnotherIncomesParticipation = Math.round(
                        ((totalAnotherIncomes) 
                        / safeValue(totalIncomesRounded)) * 100 * 100
                    ) / 100;

                    // Asegurar que totalizedFamiliarExpenses existe y no es null o undefined
                    const totalizedFamiliarExpenses = (cashFlowData_ && cashFlowData_.totalizedFamiliarExpenses !== undefined && cashFlowData_.totalizedFamiliarExpenses !== null) 
                        ? cashFlowData_.totalizedFamiliarExpenses 
                        : 0;

                    // Asegurar que loanPayment sea un número válido
                    const loanPayment = (agroData_ && agroData_.creditParameters && agroData_.creditParameters.loanPayment !== undefined && agroData_.creditParameters.loanPayment !== null) 
                        ? parseFloat(agroData_.creditParameters.loanPayment) 
                        : 0;

                    // Acceder a assessmentAmount sin `?.`
                    const assessmentAmount = (this.$store.state.assesments 
                        && this.$store.state.assesments[this.$store.state.actualAssesment] 
                        && this.$store.state.assesments[this.$store.state.actualAssesment].amount !== undefined)
                        ? this.$store.state.assesments[this.$store.state.actualAssesment].amount
                        : 0;
                    
                    // Asegurar que los valores existen y no son undefined o null
                    const totalPassivePatrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.total_passive_patrimony !== undefined)
                        ? this.form.b.passives.total_passive_patrimony
                        : 0;

                    const patrimony = (this.form && this.form.b && this.form.b.passives && this.form.b.passives.patrimony !== undefined && this.form.b.passives.patrimony !== 0)
                        ? this.form.b.passives.patrimony
                        : 1; // Evita división por 0

                    // Calcular financialIndicatorAgro1 de forma segura
                    let financialIndicatorAgro1 = (totalPassivePatrimony + assessmentAmount) / patrimony;

                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro1 = Math.round(financialIndicatorAgro1 * 100) / 100;

                    // Calcular financialIndicatorAgro de forma segura
                    let financialIndicatorAgro = 
                        (totalIncomesRounded - (totalExpensesSum + totalizedFamiliarExpenses) + assessmentAmount) / 
                        (loanPayment * clientTerm || 1); // Evita división por 0 si loanPayment es 0
                    
                    // Redondear y asignar el resultado
                    this.financialIndicatorAgro2 = Math.round(financialIndicatorAgro * 100) / 100;

                    var dataConsolidated = {
                        incomes: {
                            totalIncomesRounded: totalIncomesRounded
                        },
                        expenses: {
                            totalSum: totalExpensesSum
                        },
                        others: {
                            
                        },
                        participations: {
                            agroIncomesParticipation: agroIncomesParticipation,
                            agroExpensesParticipation: agroExpensesParticipation,
                            agroAnotherIncomesParticipation: agroAnotherIncomesParticipation
                        }
                    }
                    this.setCashFlowBalance(dataConsolidated);
                }
            }
            else {
                this.showNotificationError('No estás en una sección permitida');
            }
        }
    }
}
</script>
<style>
.fab-main .material-icons{
    color: black !important;
    background-color: #F09500 !important;
}
.fab-list li .material-icons{
    color: black !important;
    font-family: "Helvetica Neue" !important;
    font-size: 12px !important;
}
.center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
.orange {
    color: #F09500;
}
.white {
    color: white;
}
.pyme-data {
    margin: 0;
    padding: 0;
}
</style>